import { useTheme } from '@emotion/react';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Button,
  Dialog,
  Grid,
  Pagination,
  Popover,
  Stack,
  TextField,
  useMediaQuery,
} from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import { alpha, styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Avatar from 'antd/es/avatar/avatar';
import {
  addBuyerToStagingTwo,
  forwardBuyeractiontoVendor,
  forwardBuyersOfferToOtherBuyers,
  forwardOfferToBuyer,
  forwardOfferToVendor,
  getApiCall,
  Moxoseparationinlisting,
  postApiCall,
} from 'api/apiService';
import Dp from 'assets/dummy/buy.jpg';
import BlueTick from 'assets/icons/blueTick.svg';
import Monetize from 'assets/icons/dollar.svg';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import { BuyerRegisterCard } from 'component/BuyerRegistration/BuyerRegisterCard';
import { Feedback } from 'component/BuyersCard/Feedback';
import {
  Pendingwarning,
  Warning,
} from 'component/BuyersMarketplace/MakeOffers';
import {
  GET_BINDERID,
  LOGGED_FROM,
  PUBLISH_WINNER,
  USER_MAIL_ID,
} from 'constant/app.config';
import { datacontext } from 'modules/AppLayout/AppLayout';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useContext, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { poppins400, poppins500, fontsize14 } from 'theme/common.style';
import { Contact, OfferContainer } from './BuyerRegistration.util';
import SelectMenu from './components/Actionbtn';
import BadgeButton, { getColor } from './components/BadgeButton';
import TableDropdown from './components/TableDropdown';
import { WarningLite } from './components/WarningLite';
import EnhancedforwardTable from './ForwardToOtherBuyerTable';
import ManageOffer from './ManageOffer';
import VendorSelectMenu from './VendorSelectMenu';
import TableAccordion from './TableAccordion';
import dayjs from 'dayjs';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { useLocation } from 'react-router-dom';
import Requestdeposit from './components/RequestDepositPopup';
import DetailsPopup from 'component/VendorStatusContainer/DepositManager/StatusDetailsPopups/DetailsPopup';
import Loading from 'assets/images/loading.png';
import ViewCommenceEsignPdf from 'component/BuyersMarketplace/ViewCommenceEsignPdf';
import NameTooltip from 'component/Common/NameTooltip';

const TrophyIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5842 12.9359C13.9042 11.9239 15.8402 10.4279 15.8402 4.8399V4.3999H6.16016V4.8399C6.16016 10.4279 8.14016 11.9239 9.41616 12.9359C10.1642 13.5079 10.5602 13.8159 10.5602 14.5199V15.8399C9.85616 15.9279 9.15216 16.1919 8.88816 16.7199H7.92016C7.43616 16.7199 7.04016 17.1159 7.04016 17.5999H14.9602C14.9602 17.1159 14.5642 16.7199 14.0802 16.7199H13.1122C12.8482 16.1919 12.1882 15.9279 11.4402 15.8399V14.5199C11.4402 13.8159 11.7922 13.5079 12.5842 12.9359ZM11.0002 13.1559C10.7362 12.8039 10.3402 12.4959 9.98816 12.2319C8.80016 11.3079 7.17216 10.0759 7.08416 5.2799H15.0042C14.9162 10.0319 13.2882 11.3079 12.1002 12.2319C11.6602 12.5399 11.2642 12.8039 11.0002 13.1559Z"
        fill="#2F3F5E"
      />
      <path
        d="M8.27153 11.8798C8.22753 11.8798 3.51953 10.8678 3.51953 5.71979V5.27979H6.59953V6.15979H4.39953C4.66353 10.2078 8.40353 10.9998 8.44753 10.9998L8.27153 11.8798Z"
        fill="#2F3F5E"
      />
      <path
        d="M13.7268 11.8798L13.5508 10.9998C13.7268 10.9558 17.3348 10.1638 17.5988 6.15979H15.3988V5.27979H18.4788V5.71979C18.4788 10.8678 13.7708 11.8798 13.7268 11.8798Z"
        fill="#2F3F5E"
      />
    </svg>
  );
};

const UserNameDownArrow = () => {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.08761 0.246003C1.24588 0.0880873 1.49356 0.0737313 1.66809 0.202935L1.71809 0.246003L5.29036 3.81034L8.86264 0.246003C9.02092 0.0880873 9.26859 0.0737313 9.44312 0.202935L9.49312 0.246003C9.6514 0.40392 9.66578 0.651033 9.53629 0.825166L9.49312 0.875055L5.6056 4.75377C5.44733 4.91168 5.19966 4.92604 5.02513 4.79684L4.97512 4.75377L1.08761 0.875055C0.913506 0.701347 0.913506 0.419711 1.08761 0.246003Z"
        fill="black"
      />
    </svg>
  );
};
const UserNameUpArrow = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49442 4.95907C9.33615 5.11699 9.08847 5.13135 8.91395 5.00214L8.86394 4.95907L5.29167 1.39474L1.71939 4.95907C1.56112 5.11699 1.31344 5.13135 1.13891 5.00214L1.08891 4.95907C0.930635 4.80116 0.916247 4.55405 1.04574 4.37991L1.08891 4.33002L4.97643 0.45131C5.1347 0.293394 5.38238 0.279038 5.5569 0.408242L5.60691 0.45131L9.49442 4.33002C9.66853 4.50373 9.66853 4.78537 9.49442 4.95907Z"
        fill="black"
      />
    </svg>
  );
};

export const RequestIcon = ({ color }) => {
  return (
    <svg
      width="21"
      height="29"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38707_172416)">
        <path
          d="M20.8438 20.2996H19.7656C19.9812 19.5746 20.125 18.8496 20.125 18.1246C20.125 14.4996 17.25 11.5996 13.6562 11.5996C10.0625 11.5996 7.1875 14.4996 7.1875 18.1246C7.1875 18.8496 7.33125 19.5746 7.54688 20.2996H6.46875C6.0375 20.2996 5.75 20.5896 5.75 21.0246C5.75 21.4596 6.0375 21.7496 6.46875 21.7496H14.95H18.6156H20.7719C21.2031 21.7496 21.4906 21.4596 21.4906 21.0246C21.4906 20.5896 21.275 20.2996 20.8438 20.2996ZM8.625 18.1246C8.625 15.2971 10.8531 13.0496 13.6562 13.0496C16.4594 13.0496 18.6875 15.2971 18.6875 18.1246C18.6875 18.8496 18.5437 19.6471 18.1844 20.2996H16.1C16.1 20.2271 16.1 20.1546 16.1 20.0821C16.1 18.9946 15.2375 18.1246 14.1594 18.1246H12.9375C12.65 18.1246 12.4344 17.9071 12.4344 17.6171C12.4344 17.3271 12.65 17.1096 12.9375 17.1096H15.3094C15.7406 17.1096 16.0281 16.8196 16.0281 16.3846C16.0281 15.9496 15.7406 15.6596 15.3094 15.6596H14.375V15.2246C14.375 14.7896 14.0875 14.4996 13.6562 14.4996C13.225 14.4996 12.9375 14.7896 12.9375 15.2246V15.7321C11.9313 15.8046 11.1406 16.6021 11.1406 17.6171C11.1406 18.7046 12.0031 19.5746 13.0813 19.5746H14.3031C14.5906 19.5746 14.8063 19.7921 14.8063 20.0821C14.8063 20.1546 14.8062 20.2271 14.7344 20.2996H9.2C8.76875 19.6471 8.625 18.8496 8.625 18.1246Z"
          fill={color}
        />
        <path
          d="M3.59375 13.0492C4.16875 13.0492 4.74375 12.8317 5.10312 12.3967C5.4625 12.0342 5.67812 11.5992 5.75 11.0917L7.1875 11.4542C7.33125 11.5267 7.54688 11.5267 7.69062 11.5267C8.12187 11.5267 8.48125 11.3817 8.84063 11.1642L13.6562 8.11922L17.0344 10.9467C17.3938 11.2367 17.8969 11.4542 18.4 11.4542C18.5438 11.4542 18.7594 11.4542 18.9031 11.3817L21.0594 10.8017C21.275 10.7292 21.4906 10.5117 21.5625 10.2942C21.6344 10.0767 21.5625 9.78672 21.3469 9.56922L15.3094 3.47922C14.8781 3.11672 14.375 2.89922 13.8 2.89922H5.60625C5.31875 2.02922 4.52813 1.44922 3.59375 1.44922C2.37187 1.44922 1.4375 2.39172 1.4375 3.62422V10.8742C1.4375 12.1067 2.37187 13.0492 3.59375 13.0492ZM14.3031 4.56672L19.4781 9.78672L18.5437 10.0042C18.3281 10.0767 18.1125 10.0042 17.8969 9.85922L14.1594 6.74172C14.0875 6.66922 14.0875 6.66922 14.0156 6.66922C14.0156 6.66922 14.0156 6.66922 13.9437 6.66922C13.8719 6.52422 13.7281 6.52422 13.6562 6.52422H8.625C8.19375 6.52422 7.90625 6.81422 7.90625 7.24922C7.90625 7.68422 8.19375 7.97422 8.625 7.97422H11.1406L8.05 9.93172C7.90625 10.0042 7.69062 10.0767 7.475 10.0042L5.75 9.56922V4.34922H13.8C13.9438 4.34922 14.1594 4.42172 14.3031 4.56672ZM2.875 3.62422C2.875 3.18922 3.1625 2.89922 3.59375 2.89922C4.025 2.89922 4.3125 3.18922 4.3125 3.62422V10.1492V10.8742C4.3125 11.0917 4.24062 11.2367 4.09687 11.3817C3.95312 11.5267 3.80938 11.5992 3.59375 11.5992C3.1625 11.5992 2.875 11.3092 2.875 10.8742V3.62422Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_38707_172416">
          <rect width="21" height="21" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    buyeroffer,
    tableData,
    vendorstatustable,
    setForwardOfferCheckList,
    forwardOfferCheckList,
    tableChecked,
    setTableChecked,
    propertyDetails,
    vendorside,
    forwardBuyersOfferToOtherBuyersui,
    tableCheckedpopup,
    setTableCheckedpopup,
    selectCheckBox,
    buyerRegisterCheckBox,
    setBuyerRegisterChecked,
    buyerRegisterChecked,
    selectedUserNames,
    setSelectedUserNames,
    selectedUserSurNames,
    setSelectedUserSurNames,
    forwardbuyernotify,
    StageTwo,
    conditionToggle,
    handleStage2PopupOpen,
    showPendingTable,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const location = useLocation();
  const { dashboardOpenBannerNominateWinnerPopup } = location?.state || {};

  const [clearingToggle, setClearingToggle] = useState(false);

  useEffect(() => {
    if (!StageTwo || !Array.isArray(tableData)) return;

    setTimeout(() => setClearingToggle(false), 0);
  }, [conditionToggle, StageTwo, tableData]);

  useEffect(() => {
    if (!StageTwo || !Array.isArray(tableData)) return;

    if (conditionToggle == '1') {
      const validIds = tableData
        .filter((row) => row?.logWData == 1)
        .map(
          (row) =>
            row?.buyerOfferDetails?.offerUniqueId ??
            row?.buyerDetails?.user?.userId
        )
        .filter((id) => id);

      setForwardOfferCheckList((prev) =>
        prev.filter((id) => validIds.includes(id))
      );

      const allSelected =
        validIds.length > 0 &&
        validIds.every((id) => forwardOfferCheckList.includes(id));
      setTableChecked(allSelected);
    } else {
      const allIds = tableData
        .map(
          (row) =>
            row?.buyerOfferDetails?.offerUniqueId ??
            row?.buyerDetails?.user?.userId
        )
        .filter((id) => id);

      const allSelected =
        allIds.length > 0 &&
        allIds.every((id) => forwardOfferCheckList.includes(id));
      setTableChecked(allSelected);
    }
  }, [conditionToggle, StageTwo, tableData, forwardOfferCheckList]);

  return (
    <TableHead sx={{ width: '100%' }}>
      <TableRow sx={{ width: '100%' }}>
        <TableCell padding="checkbox" sx={{ width: '0.5%' }}>
          <Typography style={{ padding: '20px 5px 20px 10px' }}>
            {vendorstatustable && forwardbuyernotify && (
              <input
                checked={tableChecked}
                onClick={(e) => {
                  setTableChecked(!tableChecked);
                  const checkbox = e.target;
                  if (checkbox.checked) {
                    let array = [];
                    for (let index = 0; index < tableData.length; index++) {
                      const propertyOfferBuyerId =
                        tableData[index]?.buyerOfferDetails?.offerUniqueId ||
                        '';
                      const offerStatusVendor =
                        tableData[index]?.buyerOfferDetails?.offerStatusVendor;
                      if (
                        propertyOfferBuyerId !== '' &&
                        offerStatusVendor !== 'Buyer Notified'
                      ) {
                        const userName =
                          tableData[index]?.buyerDetails?.user?.userName || '';
                        const userSurName =
                          tableData[index]?.buyerDetails?.user?.userSurName ||
                          '';
                        array.push(propertyOfferBuyerId);
                        selectedUserNames.push(userName);
                        selectedUserSurNames.push(userSurName);
                      }
                    }
                    setForwardOfferCheckList(array);
                    setSelectedUserNames(selectedUserNames);
                    setSelectedUserSurNames(selectedUserSurNames);
                  } else {
                    setForwardOfferCheckList([]);
                    setSelectedUserNames([]);
                    setSelectedUserSurNames([]);
                  }
                }}
                padding="checkbox"
                type="checkbox"
              />
            )}
            {vendorstatustable && !forwardbuyernotify && StageTwo && (
              <input
                type="checkbox"
                checked={tableChecked}
                disabled={
                  conditionToggle === '1' &&
                  !tableData?.some((row) => row?.logWData == 1)
                }
                onChange={(e) => {
                  const checked = e.target.checked;
                  const hasUnhandled = tableData?.some(
                    (row) => row?.isUnhandled
                  );
                  if (
                    checked &&
                    hasUnhandled &&
                    typeof handleStage2PopupOpen === 'function'
                  ) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleStage2PopupOpen(null);
                    return;
                  }
                  setTableChecked(checked);

                  let selectedIds = [];

                  if (checked) {
                    selectedIds = tableData
                      .filter((row) => {
                        if (conditionToggle === '1') {
                          return row?.logWData == 1;
                        }
                        return true;
                      })
                      .map((row) => {
                        const offerUniqueId =
                          row?.buyerOfferDetails?.offerUniqueId;
                        const buyerId = row?.buyerDetails?.user?.userId;
                        if (
                          Array?.isArray(offerUniqueId) &&
                          offerUniqueId?.length == 0
                        ) {
                          return buyerId;
                        }
                        return offerUniqueId ?? buyerId;
                      })
                      .filter((id) => id);
                  }
                  setForwardOfferCheckList(selectedIds);
                }}
              />
            )}
            {vendorstatustable && !forwardbuyernotify && !StageTwo && (
              <input
                checked={tableChecked}
                onClick={(e) => {
                  setTableChecked(!tableChecked);
                  const checkbox = e.target;
                  if (checkbox.checked) {
                    let array = [];
                    for (let index = 0; index < tableData.length; index++) {
                      const buyerId =
                        tableData[index]?.buyerDetails?.user?.userId;
                      const propertyOfferBuyerId =
                        tableData[index]?.buyerOfferDetails?.offerUniqueId ||
                        buyerId;
                      if (propertyOfferBuyerId !== '') {
                        array.push(propertyOfferBuyerId);
                      }
                    }
                    setForwardOfferCheckList(array);
                  } else {
                    setForwardOfferCheckList([]);
                  }
                }}
                padding="checkbox"
                type="checkbox"
              />
            )}
            {vendorside && (
              <input padding="checkbox" type="checkbox" disabled />
            )}
            {!vendorstatustable && !vendorside && (
              <input
                checked={buyerRegisterChecked}
                onClick={(e) => {
                  setBuyerRegisterChecked(!buyerRegisterChecked);
                  selectCheckBox();
                  setTableChecked(!tableChecked);
                  const checkbox = e.target;
                  if (checkbox.checked) {
                    let array = [];
                    for (let index = 0; index < tableData.length; index++) {
                      const propertyOfferBuyerId =
                        tableData[index]?.buyerOfferDetails?.offerUniqueId ||
                        '';
                      array.push(propertyOfferBuyerId);
                    }
                  }
                }}
                padding="checkbox"
                type="checkbox"
              />
            )}
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            color: '#666666',
            paddingLeft: '75px',
          }}
        >
          Name
        </TableCell>
        {!vendorside && (
          <TableCell
            sx={{
              fontSize: '10px',
              fontWeight: 400,
              fontFamily: 'poppins',
              textAlign: 'left',
              color: '#666666',
            }}
          >
            Contact
          </TableCell>
        )}
        {!buyeroffer && !vendorside && (
          <TableCell
            sx={{
              fontSize: '10px',
              fontWeight: 400,
              fontFamily: 'poppins',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              width: '25%',
              color: '#666666',
            }}
          >
            Buyer Readiness
          </TableCell>
        )}
        {!vendorside && (
          <TableCell
            sx={{
              fontSize: '10px',
              fontWeight: 400,
              fontFamily: 'poppins',
              textAlign: 'left',
              width: '10%',
              color: '#666666',
            }}
          >
            Status
          </TableCell>
        )}
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            color: '#666666',
          }}
        >
          Offer
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            // paddingRight: '80%',
            width: '10%',
            color: '#666666',
          }}
        >
          #Offers
        </TableCell>
        {!buyeroffer && !StageTwo && (
          <>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'center',
                width: '10%',
                whiteSpace: 'nowrap',
                color: '#666666',
              }}
            >
              Ratings
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                width: '10%',
                color: '#666666',
              }}
            >
              EXP
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                color: '#666666',
              }}
            >
              Profile
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                color: '#666666',
                whiteSpace: 'nowrap',
              }}
            >
              Current Status
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'center',
                width: '30%',
                color: '#666666',
              }}
            >
              Actions
            </TableCell>
          </>
        )}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.string.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        ></Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export const collectId = (
  tableData,
  id,
  setBuyerId,
  setPosition,
  setArrayCollection
) => {
  let arrayCollection = [];
  if (tableData?.length > 0) {
    for (let index = 0; index < tableData?.length; index++) {
      const element = tableData[index]?.buyerDetails?.user?.userId;
      arrayCollection.push(element);
    }
    setArrayCollection(arrayCollection);
    setBuyerId(id);

    let position = arrayCollection.indexOf(id);
    setPosition(position);
  }
};

const CircularProgressWithProfile = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: '#C4C4C461' }}
        thickness={5}
        size={43}
      />
      <CircularProgress
        variant="determinate"
        value={props.value}
        sx={{ color: '#10D35E', position: 'absolute' }}
        thickness={5}
        size={43}
      />
      <Box
        sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          {props?.profileImage == '' || props?.profileImage == null ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                backgroundColor: '#666666',
              }}
            >
              {props.name}
            </Avatar>
          ) : (
            <Avatar
              alt={props.name}
              src={props?.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Typography>
      </Box>
    </Box>
  );
};
const CircularProgressWithProfileVendor = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: '#C4C4C461' }}
        thickness={5}
        size={43}
      />
      <CircularProgress
        variant="determinate"
        value={props.value}
        sx={{ color: '#10D35E', position: 'absolute' }}
        thickness={5}
        size={43}
      />
      <Box
        sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          {props?.profileImage == '' || props?.profileImage == null ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                backgroundColor: '#666666',
              }}
            >
              {props.name}
            </Avatar>
          ) : (
            <Avatar
              alt={props.name}
              src={props?.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default function EnhancedTable(props) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches380 = useMediaQuery(theme.breakpoints.down(380));
  const matches1000 = useMediaQuery(theme.breakpoints.down(1000));
  const [updatefunc, setUpdatefunc] = useState(false);
  const [manageOffer, setManageOffer] = useState(false);
  const [isVendorHistoryId, setisVendorHistoryId] = useState(false);
  const {
    selectedBuyerid,
    openbuyercard,
    setOpenbuyercard,
    setShowMessage,
    setMessagedata,
  } = useContext(datacontext);
  const [requestdeposit, setRequestdeposit] = useState(false);
  const [depositdetails, setDepositdetails] = useState(false);
  const [depositRes, setDepositRes] = useState('');
  const [selectedrow, setSelectedrow] = useState({});
  const [openViewDialog, setOpenViewDialog] = useState(false);

  const manageOfferClick = () => {
    setManageOffer(true);
  };

  const handleCloseView = () => {
    setOpenViewDialog(false);
    setSelectedRowFor66W(null);
  };

  const handleOpen66WDialog = (row) => {
    setSelectedRowFor66W(row);
    setOpenViewDialog(true);
  };

  const {
    getListInfo,
    onShowChat,
    vendorPropertyId,
    propertyDetails,
    stage,
    propertyidVendor,
    propertyId,
    forwardtootherbuyerstatus,
    selectedrowbuyeridfilter,
    publishwinner,
    forwardBuyersOfferToOtherBuyersui,
    setSelbuyerId,
    buyerpropertylist,
    getdata,
    userTypeValue,
    StageTwo,
    portraitMode,
    setIsSwalOpen,
    setIsPipelineCat,
    setPipelineCat,
    setPipelineId,
    setIsAppraisal,
    pendingTable,
    conditionToggle,
    handleStage2PopupOpen,
    setVendorGeneratePdf,
  } = props;

  const [selectedBuyers, setSelectedBuyers] = React.useState([]);
  const [buyerId, setBuyerId] = React.useState('');
  const [userType, setUserType] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [expandFeedback, setExpandFeedback] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [isHiddenRightArrow, setIsHiddenRightArrow] = useState(true);
  const [selectedBuyerId, setSelectedBuyerId] = useState('');
  const [openBox, setOpenBox] = useState(false);
  const [openBoxAnother, setOpenBoxAnother] = useState(false);
  const [openVendorStatusBox, setOpenVendorStatusBox] = useState(false);
  const [shareMarketPlace, setShareMarketPlace] = useState(false);
  const [
    openforwardbuyeractiontovendorBox,
    setOpenForwardBuyerActionToVendorBox,
  ] = useState(false);
  const [openpublishwinnerbox, setOpenPublishWinnerBox] = useState(false);
  const [publishLoader, setPublishLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [isPopupOpen, setIsPopupOpen] = useState(null);
  const [row, setRow] = React.useState({});
  const [position, setPosition] = useState(0);
  const [arrayCollection, setArrayCollection] = useState([]);
  const [openOwner, setOpenOwner] = useState(false);
  const [counterOfferDialog, setCounterOfferDialog] = React.useState(false);
  const [itemObj, setItemObj] = useState({});
  const [forwardtobuyer, setForwardtobuyer] = useState(false);
  const [forwardtootherbuyer, setForwardtootherbuyer] = useState(false);
  const [vendorAction, setVendorAction] = useState('');
  const [errorMessage, setErrorMessage] = useState({
    helperText: '',
    error: false,
  });
  const [vendorOffer, setVendorOffer] = useState(0);
  const handleKeyPress = (event) => {
    if (event.key === 'e' || event.key === 'E' || event.key === '-') {
      event.preventDefault();
    }
  };
  const useStyles = makeStyles({
    noSpinArrows: {
      '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
        {
          '-webkit-appearance': 'none',
          margin: 0,
        },
    },
    '@keyframes blink': {
      '0%': { backgroundColor: 'inherit', color: '#2F3F5E' },
      '50%': {
        background: 'linear-gradient(162.58deg, #e3e3e3 1.87%, #e3e3e3 98.78%)',
        color: 'white',
      },
      '100%': { backgroundColor: 'inherit', color: '#2F3F5E' },
    },
    blinking: {
      animation: `$blink 1s step-start infinite`,
    },
  });

  const classes = useStyles();
  const [highlight, setHighlight] = useState(false);
  useEffect(() => {
    if (selectedBuyerid != '') {
      setHighlight(true);
      const timer = setTimeout(() => {
        setHighlight(false);
      }, 10000);

      // Cleanup the timeout if the component unmounts
      return () => clearTimeout(timer);
    }
  }, [selectedBuyerid]);

  const handleMenuItemClick = (itemId) => {
    if (itemId === 1) {
      setShowModal(true);
    } else {
      // Handle other menu item clicks
    }
  };

  const [forwardVendorLoading, setForwardVendorLoading] = useState(false);
  const [buyerToVendorLoading, setBuyerToVendorLoading] = useState(false);
  const [frdOfferToVendorLoading, setFrdOfferToVendorLoading] = useState(false);
  const [propertyProgressValue, setPropertyProgressValue] = useState();
  const [propertyProgressRating, setPropertyProgressRating] = useState();
  const [anchorElBuyer, setAnchorElBuyer] = useState(null);
  const [anchorElProperty, setAnchorElProperty] = useState(null);
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [anchorElExp, setAnchorElExp] = useState(null);
  const [buyerName, setBuyerName] = useState('');
  const [buyerSurName, setBuyerSurName] = useState('');
  const [exp, setExp] = useState('');
  const [buyerProfileStatus, setBuyerProfileStatus] = useState('');
  const [buyerReadinessValue, setBuyerReadinessValue] = useState();
  const [detailsShow, setDetailsShow] = useState(false);

  const buyerReadiness = (event, value, name, surname) => {
    setAnchorElBuyer(event.currentTarget);
    setBuyerReadinessValue(value);
    setBuyerName(name);
    setBuyerSurName(surname);
  };
  const openBuyer = Boolean(anchorElBuyer);
  const idBuyer = openBuyer ? 'simple-popover' : undefined;

  const handleCloseBuyer = () => {
    setAnchorElBuyer(null);
  };

  const propertyProgress = (value, rating, event, name, surname) => {
    setPropertyProgressValue(value);
    setPropertyProgressRating(rating);
    setAnchorElProperty(event.currentTarget);
    setBuyerName(name);
    setBuyerSurName(surname);
  };

  const openProperty = Boolean(anchorElProperty);
  const idProperty = openProperty ? 'simple-popover' : undefined;

  const handleCloseProperty = () => {
    setAnchorElProperty(null);
  };

  const PropertyRatingIcon = ({ rating = 0 }) => {
    const value = Number(rating) || 0;

    return (
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          width: 33,
          height: 33,
          verticalAlign: 'middle',
        }}
      >
        <CircularProgress
          variant="determinate"
          value={100}
          size={33}
          thickness={5}
          sx={{
            color: '#C4C4C461',
            position: 'absolute',
          }}
        />

        <CircularProgress
          variant="determinate"
          value={value * 10}
          size={33}
          thickness={5}
          sx={{
            color: '#10D35E',
            position: 'absolute',
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: '11px',
              fontWeight: 600,
              color: '#112347',
              lineHeight: 1,
            }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    );
  };

  const buyerExp = (event, name, exp1, surname) => {
    setAnchorElExp(event.currentTarget);
    setBuyerName(name);
    setBuyerSurName(surname);
    setExp(exp1);
  };

  const openExp = Boolean(anchorElExp);
  const idExp = openExp ? 'simple-popover' : undefined;

  const handleCloseExp = () => {
    setAnchorElExp(null);
  };

  const buyerProfile = (event, name, value, surname) => {
    setAnchorElProfile(event.currentTarget);
    setBuyerName(name);
    setBuyerSurName(surname);
    setBuyerProfileStatus(value);
  };

  const openProfile = Boolean(anchorElProfile);
  const idProfile = openProfile ? 'simple-popover' : undefined;

  const handleCloseProfile = () => {
    setAnchorElProfile(null);
  };

  const {
    headCells,
    tableData,
    buyeroffer,
    vendorstatustable,
    address,
    vendorside,
    setForwardOfferCheckList,
    forwardOfferCheckList,
    propertyUniqueId,
    days,
    hours,
    minutes,
    seconds,
    selectedUserNames,
    setSelectedUserNames,
    selectedUserSurNames,
    setSelectedUserSurNames,
    forwardbuyernotify,
    vendorDatas,
    showPendingTable,
  } = props;
  const [feedBackData, setFeedBackData] = useState(null);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [indexValue, setIndexValue] = React.useState(null);
  const [showBackdrop, setShowBackDrop] = React.useState(false);
  const [buyerOfferPrice, setbuyerOfferPrice] = React.useState(false);
  const [selectedrowbuyerid, setSelectedrowbuyerid] = React.useState(false);
  const [selectedrowbuyername, setSelectedrowbuyername] = React.useState(false);
  const [selectedRowFor66W, setSelectedRowFor66W] = useState(null);
  const [userName, setUserName] = React.useState('');
  const [userInitial, setUserInitial] = useState('');
  const [userMobile, setUserMobile] = React.useState('');
  const [userEmail, setUserEmail] = React.useState('');
  const [userAddress, setUserAddress] = React.useState('');
  const [userNoOfOffers, setUserNoOfOffers] = React.useState('');
  const [userPreviousOffer, setUserPreviousOffer] = React.useState('');
  const [loading, setLoading] = useState(false);
  const [MessagetToBuyer, setMessagetToBuyer] = useState('');
  const [manageofferrow, setManageofferrow] = useState('');
  const [offerHistory, setOfferHistory] = useState([]);
  const [openhistorydialog, setOpenhistorydialog] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalItems = tableData?.length || 0;
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // pagination sliced data
  const currentItems = Array.from(tableData || []).slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = tableData.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (isChecked, index, buyerId, row, userCategory) => {
    setIndexValue(index);
    setOpen(true);
    setBuyerId(buyerId);
    setSelbuyerId(buyerId);
    setRow(row);
    setUserName(row?.buyerDetails?.user?.userName);
    setUserMobile(row?.buyerDetails?.userMobile);
    setUserEmail(row?.buyerDetails?.userEmail);
    setUserAddress(row?.buyerDetails?.userAddress);
    setUserPreviousOffer(row?.buyerDetails?.previouslyOfferMade);
    setUserNoOfOffers(row?.buyerDetails?.noOfOffers);
    setIsHiddenRightArrow(true);
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    let userType = '';
    if (userCategory?.length > 1) {
      userType = 'Both';
    } else if (
      userCategory?.filter((e) => e.userType === 'Buyer')?.length > 0
    ) {
      userType = 'Buyer';
    }

    setSelected(newSelected);
    setUserType(userType);
    if (userType === 'Buyer') {
      if (isChecked) {
        setSelectedBuyers(
          (prevSelected) => [...prevSelected, buyerId],
          setOpen(isChecked)
        );
      } else {
        setSelectedBuyers((prevSelected) =>
          prevSelected.filter((id) => id !== buyerId, setOpen(false))
        );
      }
    }
  };
  const handleClickAction = (isChecked, index, buyerId, row, userCategory) => {
    setIndexValue(index);
    setOpen(true);
    setBuyerId(buyerId);
    setSelbuyerId(buyerId);
    setUserName(row?.buyerDetails?.user?.userName);
    setUserMobile(row?.buyerDetails?.userMobile);
    setUserEmail(row?.buyerDetails?.userEmail);
    setUserAddress(row?.buyerDetails?.userAddress);
    setUserPreviousOffer(row?.buyerDetails?.previouslyOfferMade);
    setUserNoOfOffers(row?.buyerDetails?.noOfOffers);
    setIsHiddenRightArrow(true);
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

  const handleClickBuyer = (buyerId, userType, row) => {
    setSelbuyerId(buyerId);
    setBuyerId(buyerId);
    setRow(row);
    setUserType(userType);
    setOpen(true);
    setIsHiddenRightArrow(true);
    setBuyerId(buyerId);
  };
  const [forwardBuyerCheckList, setForwardBuyerCheckList] = useState([]);
  const [forwardUsernameList, setForwardUsernameCheckList] = useState([]);
  const [forwardSurUsernameList, setForwardSurUsernameCheckList] = useState([]);
  let popuparray = [];

  const moxosepforwardOfferToBuyerFunc = (res) => {
    if (isNotEmptyArray(res?.dataForBuyerOfferSharingAck))
      Moxoseparationinlisting(
        'dataForBuyerOfferSharingAck',
        res?.dataForBuyerOfferSharingAck
      ); //1
    if (isNotEmptyArray(res?.dataForBuyerOffersAck))
      Moxoseparationinlisting(
        'dataForBuyerOffersAck',
        res?.dataForBuyerOffersAck
      ); //2
  };

  const forwardOfferToBuyerFunc = ({
    selectedrowbuyername,
    buyerOfferPrice,
  }) => {
    setLoading(true);
    const combinedNames = forwardUsernameList.map(
      (name, index) => `${name} ${forwardSurUsernameList[index]}`
    );

    const isScrollable = combinedNames.length > 5;

    const formattedCombinedNames = combinedNames
      .map((name) => `- ${name}`)
      .join('<br>');
    const successMessage =
      combinedNames.length > 1
        ? `<span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${selectedrowbuyername}</span>'s offer of <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${buyerOfferPrice}</span> has been shared with the selected buyers: <br> ${
            isScrollable
              ? `<div style="height: 130px; overflow-y: scroll; -webkit-overflow-scrolling: touch; scrollbar-width: auto; scrollbar-color: #888 #f1f1f1;"><span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${formattedCombinedNames}</span></div>`
              : `<span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${formattedCombinedNames}</span>`
          }`
        : `<span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${selectedrowbuyername}</span>'s offer of <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${buyerOfferPrice}</span> has been shared with the selected buyer:<br> <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${formattedCombinedNames}</span>`;

    let input = {
      offerUniqueId: offerUniqueId,
      isMarket: forwardBuyerCheckList?.length > 0 ? 0 : 1,
      buyerArr:
        forwardBuyerCheckList?.length > 0 ? forwardBuyerCheckList : null,
      message: MessagetToBuyer,
    };

    forwardBuyersOfferToOtherBuyers(input)
      .then((res) => {
        if (res?.status == '1') {
          setLoading(false);
          setForwardtobuyer(!forwardtobuyer);
          setMessagetToBuyer('');
          getListInfo();
          moxosepforwardOfferToBuyerFunc(res);

          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            html: `<div style="text-align: left;">${successMessage}</div>`,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setForwardtobuyer(!forwardtobuyer);
          setLoading(false);
          setMessagetToBuyer('');
          getListInfo();
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setLoading(false));
  };

  const ExpIcon = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7626 6.80661C14.7626 9.18634 12.8546 11.0945 10.4732 11.0945C8.0926 11.0945 6.18374 9.18634 6.18374 6.80661C6.18374 4.42688 8.0926 2.51953 10.4732 2.51953C12.8546 2.51953 14.7626 4.42688 14.7626 6.80661ZM10.4732 18.7245C6.95865 18.7245 3.99121 18.1533 3.99121 15.9494C3.99121 13.7447 6.97729 13.1937 10.4732 13.1937C13.9886 13.1937 16.9552 13.7649 16.9552 15.9689C16.9552 18.1736 13.9691 18.7245 10.4732 18.7245Z"
          fill="#F74646"
        />
      </svg>
    );
  };
  const GreyPaper = () => {
    return (
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#C4C4C4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
        />
      </svg>
    );
  };
  const ColorPaper = () => {
    return (
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
          fill="#6C2AD2"
        />
      </svg>
    );
  };

  const [offerUniqueId, setOfferUniqueId] = useState('');
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [offerStatus, setofferStatus] = useState('');
  const [tableChecked, setTableChecked] = useState(false);
  const [tableCheckedpopup, setTableCheckedpopup] = useState(false);
  const [tableCheckedpopupui, setTableCheckedpopupui] = useState(false);
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const userType1 = userDetail?.primaryUserType;

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  React.useEffect(() => {
    setArrayCollection(arrayCollection);
  }, [arrayCollection]);

  useEffect(() => {
    if (
      publishLoader ||
      frdOfferToVendorLoading ||
      forwardVendorLoading ||
      buyerToVendorLoading ||
      loading
    ) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [
    publishLoader,
    frdOfferToVendorLoading,
    forwardVendorLoading,
    buyerToVendorLoading,
    loading,
  ]);
  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={props.rating * 10}
          sx={{ color: '#10D35E' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.rating == null ? 0 : props.rating}
          </Typography>
        </Box>
      </Box>
    );
  }

  const readiness = Number(row?.buyerReadiness ?? 0);
  const textColor = readiness <= 50 ? '#6C2AD2' : '#FFFFFF';
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 16,
    position: 'relative',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      background: '#FFFFFF',
      border: '0.81px solid',
      borderRadius: 2.42,
      borderColor: '#6C2AD2',
    },
    [`& .${linearProgressClasses.bar}`]: {
      background: 'linear-gradient(90deg, #77CFFE 0%, #6C2AD2 100%)',
      borderRadius: 2.42,
      transition: 'none',
    },
  }));
  const TextOverlay = styled(Typography)(({ theme, leftPosition }) => ({
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    fontSize: '10px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    fontWeight: '400px',
    alignItems: 'center',
  }));

  const buyeraction = () => {
    let input = {
      offerUniqueId: offerUniqueId,
    };
    setBuyerToVendorLoading(true);
    forwardBuyeractiontoVendor(input)
      .then((res) => {
        if (res?.status == '1') {
          setOpenForwardBuyerActionToVendorBox(
            !openforwardbuyeractiontovendorBox
          );
          getListInfo();
          setBuyerToVendorLoading(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setBuyerToVendorLoading(false);
          setOpenForwardBuyerActionToVendorBox(
            !openforwardbuyeractiontovendorBox
          );

          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setBuyerToVendorLoading(false));
  };

  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [finalContract, setOpenFinalContract] = React.useState(false);
  const [BuyerDropdown, setBuyerDropdown] = React.useState(null);
  const history = useHistory();
  const [binderID, setBinderID] = React.useState('');

  const handleClickOpenFinal = () => {
    setOpenFinalContract(true);
  };

  const handleClickCloseFinal = () => {
    setOpenFinalContract(false);
  };
  const InfoIcon = () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_25231_159917)">
          <path
            d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
            stroke="#EEAD06"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5 17.7083V17.7187"
            stroke="#EEAD06"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
            stroke="#EEAD06"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_25231_159917">
            <rect width="25" height="25" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const PersonGreen = () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0136 5.90768C14.0136 8.28741 12.1056 10.1956 9.72417 10.1956C7.34357 10.1956 5.43472 8.28741 5.43472 5.90768C5.43472 3.52796 7.34357 1.62061 9.72417 1.62061C12.1056 1.62061 14.0136 3.52796 14.0136 5.90768ZM9.72419 17.8256C6.20963 17.8256 3.24219 17.2544 3.24219 15.0505C3.24219 12.8458 6.22827 12.2948 9.72419 12.2948C13.2396 12.2948 16.2062 12.866 16.2062 15.0699C16.2062 17.2746 13.2201 17.8256 9.72419 17.8256Z"
          fill="#229E45"
          fill-opacity="0.72"
        />
      </svg>
    );
  };
  const PersonBlue = () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0136 5.90768C14.0136 8.28741 12.1056 10.1956 9.72415 10.1956C7.34355 10.1956 5.43469 8.28741 5.43469 5.90768C5.43469 3.52796 7.34355 1.62061 9.72415 1.62061C12.1056 1.62061 14.0136 3.52796 14.0136 5.90768ZM9.72416 17.8256C6.2096 17.8256 3.24216 17.2544 3.24216 15.0505C3.24216 12.8458 6.22824 12.2948 9.72416 12.2948C13.2395 12.2948 16.2062 12.866 16.2062 15.0699C16.2062 17.2746 13.2201 17.8256 9.72416 17.8256Z"
          fill="#2FCDFF"
          fill-opacity="0.62"
        />
      </svg>
    );
  };
  const PersonYellow = () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0136 5.90768C14.0136 8.28741 12.1056 10.1956 9.72417 10.1956C7.34357 10.1956 5.43472 8.28741 5.43472 5.90768C5.43472 3.52796 7.34357 1.62061 9.72417 1.62061C12.1056 1.62061 14.0136 3.52796 14.0136 5.90768ZM9.72419 17.8256C6.20963 17.8256 3.24219 17.2544 3.24219 15.0505C3.24219 12.8458 6.22827 12.2948 9.72419 12.2948C13.2396 12.2948 16.2062 12.866 16.2062 15.0699C16.2062 17.2746 13.2201 17.8256 9.72419 17.8256Z"
          fill="#FBA729"
          fill-opacity="0.74"
        />
      </svg>
    );
  };
  const PersonRed = () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0136 5.90768C14.0136 8.28741 12.1056 10.1956 9.72417 10.1956C7.34357 10.1956 5.43472 8.28741 5.43472 5.90768C5.43472 3.52796 7.34357 1.62061 9.72417 1.62061C12.1056 1.62061 14.0136 3.52796 14.0136 5.90768ZM9.72419 17.8256C6.20963 17.8256 3.24219 17.2544 3.24219 15.0505C3.24219 12.8458 6.22827 12.2948 9.72419 12.2948C13.2396 12.2948 16.2062 12.866 16.2062 15.0699C16.2062 17.2746 13.2201 17.8256 9.72419 17.8256Z"
          fill="#F74646"
        />
      </svg>
    );
  };
  const LineIndicator = () => {
    return (
      <svg
        width="28"
        height="201"
        viewBox="0 0 28 201"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line x1="13.5" y1="-2.18557e-08" x2="13.5" y2="200" stroke="#505050" />
        <line
          x1="-4.37114e-08"
          y1="200.5"
          x2="26"
          y2="200.5"
          stroke="#505050"
        />
        <line
          x1="-4.37114e-08"
          y1="0.5"
          x2="28"
          y2="0.499998"
          stroke="#505050"
        />
      </svg>
    );
  };

  const DotLine = () => {
    return (
      <svg
        width="13"
        height="2"
        viewBox="0 0 13 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 1L0 1"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-dasharray="2 2"
        />
      </svg>
    );
  };

  const StraightLine = () => {
    return (
      <svg
        width="2"
        height="59"
        viewBox="0 0 2 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="1"
          y1="4.37114e-08"
          x2="0.999997"
          y2="59"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-dasharray="2 2"
        />
      </svg>
    );
  };

  const openMessage = (binderID) => {
    if (LOGGED_FROM == 'Mobile') {
      window.open(
        `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${binderID}`,
        '_blank'
      );
    } else {
      setShowMessage(true);
      setMessagedata({ binderId: binderID });
    }
    setBinderID('');
  };
  const [reqDepositOpen, setReqDepositOpen] = useState(false);
  const { bannerApiTrigger } = useContext(datacontext);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForST2EndedBuyerAck))
      Moxoseparationinlisting(
        'dataForST2EndedBuyerAck',
        res?.data?.dataForST2EndedBuyerAck
      ); //1
    if (isNotEmptyArray(res?.data?.dataForST2EndedVendorAck))
      Moxoseparationinlisting(
        'dataForST2EndedVendorAck',
        res?.data?.dataForST2EndedVendorAck
      ); //2
    if (isNotEmptyArray(res?.data?.dataForWinnerVendorAck))
      Moxoseparationinlisting(
        'dataForWinnerVendorAck',
        res?.data?.dataForWinnerVendorAck
      ); //3
    if (isNotEmptyArray(res?.data?.dataForWinnerBuyerAck))
      Moxoseparationinlisting(
        'dataForWinnerBuyerAck',
        res?.data?.dataForWinnerBuyerAck
      ); //4
  };
  const {
    winerPublishdMoveToEnded,
    winnerPopper,
    setwinnerPopper,
    setDisplayExchange,
  } = useContext(PropertyContext);

  const {
    setWinerPublishdMoveToEnded,
    openManageOfferFromVendorStatus,
    setOpenManageOfferFromVendorStatus,
  } = useContext(PropertyContext);

  const [
    endPropertyPopupFromNominateWinner,
    setEndPropertyPopupFromNominateWinner,
  ] = useState(false);

  const requested = Number(paymentStatus?.requestedDepositAmount);
  const buyerOffer = Number(paymentStatus?.buyerOfferPrice);

  const isRequestDepositCompleted = requested === buyerOffer;

  const depositStatus = paymentStatus?.buyerOfferDetails?.depositPaymentLog;
  const isDepositReceived = paymentStatus?.isDepositReceived !== 0;
  const publishwinnerfun = () => {
    setPublishLoader(true);
    const params = {
      offerUniqueId: offerUniqueId,
    };
    setDisplayExchange(false);
    postApiCall(PUBLISH_WINNER, params)
      .then((res) => {
        if (res?.data?.status == 1) {
          bannerApiTrigger();
          setOpenPublishWinnerBox(false);
          setPublishLoader(false);
          getdata();
          getListInfo();
          moxoapis(res);
          setwinnerPopper(true);
          setWinerPublishdMoveToEnded(true);
          setTimeout(() => {
            Swal.fire({
              icon: 'success',
              title: res?.data?.heading ? res?.data?.heading : 'Success',
              html: `${
                propertyDetails?.PropertyDetails?.timerStatus !== 'End'
                  ? (propertyDetails?.PropertyDetails?.stage === 'ST1'
                      ? 'Stage 1'
                      : 'Stage 2') + ' has now ended. '
                  : ''
              }<b style="font-family: Poppins; font-weight: 550; color: #666666;">
      ${selectedrowbuyername}
    </b> has been nominated as the Winner.`,

              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: isRequestDepositCompleted
                ? 'View deposit details'
                : 'Request deposit',
              cancelButtonText: isRequestDepositCompleted ? 'Close' : 'Close',
              reverseButtons: true,
            }).then(({ isConfirmed, isDismissed }) => {
              if (isConfirmed) {
                if (isRequestDepositCompleted) {
                  setDepositdetails(true);
                  return;
                } else {
                  setReqDepositOpen(offerUniqueId);
                  setTimeout(() => {
                    setRequestdeposit(true);
                  }, 100);
                  return;
                }
              } else if (isDismissed) {
                setTimeout(() => {
                  setDisplayExchange(true);
                }, 2000);
                return;
              }
            });
          }, 6000);
        } else {
          Swal.fire({
            icon: 'error',
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            confirmButtonText: 'Close',
          });
          setOpenPublishWinnerBox(false);
          setPublishLoader(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred while nominating the winner. Please try again later.',
          confirmButtonText: 'Close',
        });
        setPublishLoader(false);
      })
      .finally(() => {
        setEndPropertyPopupFromNominateWinner(true);
      });
  };
  let finalCon;

  const [buyerRegisterCheckBox, setBuyerRegisterCheckBox] = useState([]);
  const [buyerRegisterCheckBoxArr, setBuyerRegisterCheckBoxArr] = useState([]);
  const [buyerRegisterChecked, setBuyerRegisterChecked] = useState(false);

  const selectCheckBox = (ids, flag) => {
    let selectedArr = [];
    let selectedWholeArr = [];
    if (flag != 'updateId') {
      for (let index = 0; index < tableData.length; index++) {
        const id = tableData[index]?.buyerDetails?.user?.userId;
        selectedArr.push(id);
        selectedWholeArr.push(tableData[index]);
      }

      if (buyerRegisterCheckBox?.length > 0 && buyerRegisterChecked) {
        setBuyerRegisterCheckBox([]);
        setBuyerRegisterCheckBoxArr([]);
      } else {
        setBuyerRegisterCheckBox(selectedArr);
        setBuyerRegisterCheckBoxArr(selectedWholeArr);
      }
    } else {
      setBuyerRegisterChecked(false);

      if (buyerRegisterCheckBox?.includes(ids)) {
        setBuyerRegisterCheckBox((prevArray) => {
          let index = prevArray.indexOf(ids);
          if (index !== -1) {
            prevArray.splice(index, 1);
          }
          const newArray = prevArray;
          return Array.from(new Set(newArray));
        });
        setBuyerRegisterCheckBoxArr((preArr) => {
          const filteredData = preArr.filter(
            (item) => item.buyerDetails.user.userId !== ids
          );

          return filteredData;
        });
      } else {
        setBuyerRegisterCheckBox((prevArray) => {
          const newArray = [...prevArray, ids];
          return Array.from(new Set(newArray));
        });
        let selectedWholeArr = [];
        for (let index = 0; index < tableData.length; index++) {
          const id = tableData[index]?.buyerDetails?.user?.userId;
          if (id == ids) {
            selectedWholeArr.push(tableData[index]);
          }
        }
        setBuyerRegisterCheckBoxArr((prevState) =>
          prevState ? [...prevState, ...selectedWholeArr] : selectedWholeArr
        );
      }
    }
  };

  const sendProps = (index, buyerId, row, userCategory, setShowBackDrop) => {};

  useEffect(() => {
    if (openbuyercard) {
      if (tableData) {
        if (Array.isArray(currentItems) && currentItems?.length > 0) {
          currentItems?.map((row, index) => {
            const buyerId = row?.buyerDetails?.user?.userId;
            const userType = row?.buyerDetails?.userCategory[0]?.userType;
            if (buyerId == selectedBuyerid) {
              handleClickBuyer(buyerId, userType, row);
            }
          });
        }
      }
    }
  }, [openbuyercard]);

  const manageOfferClickClose = () => {
    setManageOffer(false);
    setisVendorHistoryId(false);
    setOpenManageOfferFromVendorStatus({ open: false, buyerId: null });
  };

  const [selectedOffer, setSelectedOffer] = useState();
  const [selectedOfferPrice, setSelectedOfferPrice] = useState(null);

  const handleCheckboxChange = useCallback((offerId, offerPrice) => {
    setSelectedOffer((prev) => {
      if (prev === offerId) {
        setSelectedOfferPrice(null);
        return null;
      } else {
        setSelectedOfferPrice(offerPrice);
        return offerId;
      }
    });
  }, []);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  return (
    <>
      <Box sx={{ width: '100%', padding: '5px' }}>
        <Paper
          sx={{
            width: '100%',
            mb: 2,
            boxShadow: 'none',
            border: '1.2px solid #DADADA', // 🛠️ HIGH CONTRAST: Thicker and darker for visibility at 50% zoom
            borderRadius: '5px',
            padding: '4px', // 4px internal gutter
            overflow: 'visible', // 🛠️ SAFE: Paper's own border is never clipped
            boxSizing: 'border-box',
          }}
        >
          {matchessm && portraitMode ? (
            <TableAccordion
              setBuyerRegisterChecked={setBuyerRegisterChecked}
              vendorside={vendorside}
              BlueTick={BlueTick}
              Monetize={Monetize}
              vendorstatustable={vendorstatustable}
              forwardtootherbuyerstatus={forwardtootherbuyerstatus}
              handleClickBuyer={handleClickBuyer}
              buyerId={buyerId}
              userType={userType}
              collectId={collectId}
              showBackdrop={showBackdrop}
              setShowBackDrop={setShowBackDrop}
              setBuyerId={setBuyerId}
              setPosition={setPosition}
              setArrayCollection={setArrayCollection}
              BuyerDropdown={BuyerDropdown}
              setBuyerDropdown={setBuyerDropdown}
              tableData={tableData}
              currentItems={currentItems}
              finalCon={finalCon}
              selectedBuyers={selectedBuyers}
              isSelected={isSelected}
              selectedrowbuyeridfilter={selectedrowbuyeridfilter}
              directcomm={directcomm}
              userType1={userType1}
              setOfferUniqueId={setOfferUniqueId}
              openBox={openBox}
              setOpenPublishWinnerBox={setOpenPublishWinnerBox}
              setOpenBox={setOpenBox}
              buyerRegisterCheckBox={buyerRegisterCheckBox}
              setSelectedrowbuyerid={setSelectedrowbuyerid}
              selectedrowbuyerid={selectedrowbuyerid}
              setbuyerOfferPrice={setbuyerOfferPrice}
              setOfferHistory={setOfferHistory}
              offerHistory={offerHistory}
              forwardtobuyer={forwardtobuyer}
              propertyDetails={propertyDetails}
              offerUniqueId={offerUniqueId}
              onShowChat={onShowChat}
              setOpenFeedback={setOpenFeedback}
              buyerRegisterCheckBoxArr={buyerRegisterCheckBoxArr}
              forwardBuyersOfferToOtherBuyers={forwardBuyersOfferToOtherBuyers}
              setTableChecked={setTableChecked}
              tableChecked={tableChecked}
              setForwardtobuyer={setForwardtobuyer}
              updatefunc={updatefunc}
              getListInfo={getListInfo}
              address={address}
              buyerRegisterChecked={buyerRegisterChecked}
              handleClick={handleClick}
              setSelectedrowbuyername={setSelectedrowbuyername}
              selectedrowbuyername={selectedrowbuyername}
              buyerOfferPrice={buyerOfferPrice}
              userTypeValue={userTypeValue}
              reqDepositOpen={reqDepositOpen}
              propertyId={propertyId}
              setItemObj={setItemObj}
              setVendorAction={setVendorAction}
              setReqDepositOpen={setReqDepositOpen}
              idBuyer={idBuyer}
              buyerReadiness={buyerReadiness}
              idExp={idExp}
              buyerExp={buyerExp}
              selectCheckBox={selectCheckBox}
              vendorDatas={vendorDatas}
              setManageofferrow={setManageofferrow}
              setManageOffer={setManageOffer}
              manageOffer={manageOffer}
              openhistorydialog={openhistorydialog}
              manageofferrow={manageofferrow}
              setIsSwalOpen={setIsSwalOpen}
              setisVendorHistoryId={setisVendorHistoryId}
              setOpenhistorydialog={setOpenhistorydialog}
              isVendorHistoryId={isVendorHistoryId}
              manageOfferClickClose={manageOfferClickClose}
              setSelectedCheckboxes={setSelectedCheckboxes}
              profileData={propertyDetails}
              setBuyerRegisterCheckBox={setBuyerRegisterCheckBox}
              setBuyerRegisterCheckBoxArr={setBuyerRegisterCheckBoxArr}
              setPaymentStatus={setPaymentStatus}
              setVendorGeneratePdf={setVendorGeneratePdf}
              userDetail={userDetail}
            />
          ) : (
            <TableContainer
              sx={{
                '-webkit-scrollbar': {
                  display: 'none',
                },
                '-ms-overflow-style': 'none' /* IE and Edge */,
                'scrollbar-width': 'none',
                margin: '1px 1px 20px 1px', // 🛠️ SCROLLBAR BUFFER: Large bottom margin ensures scrollbars never touch the border
                overflowX: 'auto', // 🛠️ Allow horizontal scrolling at high zoom (300%)
              }}
            >
              <Table
                sx={{
                  minWidth: '900px', // 🛠️ Ensures columns don't collapse at 300% zoom
                  borderCollapse: 'separate', // 🛠️ FIREFOX ROBUSTNESS: 'separate' is more stable than 'collapse' for zoom
                  borderSpacing: 0,
                  backgroundColor: 'white',
                }}
                aria-labelledby="tableTitle"
                size="medium"
              >
                <EnhancedTableHead
                  buyeroffer={buyeroffer}
                  headCells={headCells}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={tableData?.length}
                  vendorstatustable={vendorstatustable}
                  tableData={tableData}
                  setForwardOfferCheckList={setForwardOfferCheckList}
                  forwardOfferCheckList={forwardOfferCheckList}
                  setTableChecked={setTableChecked}
                  tableChecked={tableChecked}
                  vendorside={vendorside}
                  propertyDetails={propertyDetails}
                  forwardBuyersOfferToOtherBuyersui={true}
                  tableCheckedpopup={tableCheckedpopupui}
                  setTableCheckedpopup={setTableCheckedpopupui}
                  selectCheckBox={selectCheckBox}
                  buyerRegisterCheckBox={buyerRegisterCheckBox}
                  setBuyerRegisterCheckBox={setBuyerRegisterCheckBox}
                  setBuyerRegisterChecked={setBuyerRegisterChecked}
                  buyerRegisterChecked={buyerRegisterChecked}
                  selectedUserNames={selectedUserNames}
                  setSelectedUserNames={setSelectedUserNames}
                  selectedUserSurNames={selectedUserSurNames}
                  setSelectedUserSurNames={setSelectedUserSurNames}
                  forwardbuyernotify={forwardbuyernotify}
                  StageTwo={StageTwo}
                  conditionToggle={conditionToggle}
                  handleStage2PopupOpen={handleStage2PopupOpen}
                  {...props}
                />
                <TableBody sx={{ width: '100%' }}>
                  {tableData &&
                  Array.isArray(currentItems) &&
                  currentItems?.length > 0 ? (
                    currentItems?.map((row, index) => {
                      const buyerId = row?.buyerDetails?.user?.userId;
                      const getUserName = (userId) => {
                        const user = row?.buyerDetails?.user;
                        return user?.userName || 'Unknown';
                      };
                      const getUserSurName = (userId) => {
                        const user = row?.buyerDetails?.user;
                        return user?.userSurName || 'Unknown';
                      };
                      const propertyOfferBuyerId =
                        row?.buyerOfferDetails?.offerUniqueId || buyerId;
                      const offerUniqueId =
                        row?.buyerOfferDetails?.offerUniqueId;
                      const sharedToMarket = row?.buyerOfferDetails?.isMarket;
                      const propertyOfferBuyerIdd =
                        Array?.isArray(offerUniqueId) &&
                        offerUniqueId?.length == 0
                          ? buyerId
                          : offerUniqueId ?? buyerId;
                      const offerStatusVendor =
                        row?.buyerOfferDetails?.offerStatusVendor;
                      const offerStatus = row?.buyerOfferDetails?.offerStatus;
                      const isCardSelected = selectedBuyers.includes(buyerId);
                      const userType =
                        row?.buyerDetails?.userCategory[0]?.userType;
                      const userCategory = row?.buyerDetails?.userCategory;
                      const isItemSelected = isSelected(row.name);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      if (row?.buyerOfferDetails) {
                        if (
                          row?.buyerOfferDetails?.contractSignStatus ==
                          'Action Required'
                        ) {
                          finalCon = false;
                        } else if (
                          row?.buyerOfferDetails?.contractSignStatus ==
                          'E-sign Requested'
                        ) {
                          finalCon = false;
                        }
                      } else {
                        finalCon = true;
                      }

                      if (buyerId !== selectedrowbuyeridfilter) {
                        return (
                          <>
                            <TableRow
                              {...(!vendorside && {
                                sx: {
                                  '& > *': { borderBottom: 'unset !important' },
                                },
                              })}
                              sx={{
                                ...(StageTwo && row?.isUnhandled
                                  ? { backgroundColor: '#f2f2f2' }
                                  : {}),
                              }}
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.name}
                              className={
                                highlight &&
                                buyerId == selectedBuyerid &&
                                !openbuyercard
                                  ? classes.blinking
                                  : ''
                              }
                            >
                              <TableCell
                                padding="checkbox"
                                sx={{ width: vendorside ? '5%' : '1%' }}
                              >
                                {vendorstatustable &&
                                  !vendorside &&
                                  forwardbuyernotify && (
                                    <Typography
                                      style={{ padding: '20px 5px 20px 10px' }}
                                    >
                                      <input
                                        type="checkbox"
                                        color="primary"
                                        checked={
                                          propertyOfferBuyerId != '' &&
                                          forwardOfferCheckList.includes(
                                            propertyOfferBuyerId
                                          )
                                        }
                                        disabled={
                                          offerStatusVendor ==
                                            'Buyer Notified' ||
                                          row?.buyerOfferDetails == ''
                                        }
                                        inputProps={{
                                          'aria-labelledby': labelId,
                                        }}
                                        onClick={(e) => {
                                          setTableChecked(false);
                                          const checkbox = e.target;
                                          const userId = propertyOfferBuyerId;
                                          const userName = getUserName(userId);
                                          const userSurName =
                                            getUserSurName(userId);

                                          if (checkbox.checked) {
                                            setForwardOfferCheckList([
                                              ...forwardOfferCheckList,
                                              propertyOfferBuyerId,
                                            ]);
                                            setSelectedUserNames(
                                              (prevNames) => [
                                                ...prevNames,
                                                userName,
                                              ]
                                            );
                                            setSelectedUserSurNames(
                                              (prevNames) => [
                                                ...prevNames,
                                                userSurName,
                                              ]
                                            );
                                          } else {
                                            const index =
                                              forwardOfferCheckList.indexOf(
                                                propertyOfferBuyerId
                                              );
                                            setSelectedUserNames((prevNames) =>
                                              prevNames.filter(
                                                (name) => name !== userName
                                              )
                                            );
                                            setSelectedUserSurNames(
                                              (prevNames) =>
                                                prevNames.filter(
                                                  (name) => name !== userSurName
                                                )
                                            );
                                            if (index !== -1) {
                                              setForwardOfferCheckList(
                                                forwardOfferCheckList
                                                  .slice(0, index)
                                                  .concat(
                                                    forwardOfferCheckList.slice(
                                                      index + 1
                                                    )
                                                  )
                                              );
                                            }
                                          }
                                        }}
                                      />
                                    </Typography>
                                  )}
                                {vendorstatustable &&
                                  !vendorside &&
                                  !forwardbuyernotify &&
                                  StageTwo &&
                                  (() => {
                                    const checkboxId =
                                      row?.buyerOfferDetails?.offerUniqueId ??
                                      row?.buyerDetails?.user?.userId;

                                    const isDisabled =
                                      conditionToggle === '1' &&
                                      row?.logWData == 0;

                                    return (
                                      <Typography
                                        style={{
                                          padding: '20px 5px 20px 10px',
                                        }}
                                      >
                                        <Tooltip
                                          title={
                                            isDisabled
                                              ? 'This buyer is not yet in an Unconditional position.'
                                              : ''
                                          }
                                          disableHoverListener={!isDisabled}
                                          arrow
                                          placement="top"
                                          slotProps={{
                                            tooltip: {
                                              sx: {
                                                maxWidth: 260,
                                                fontFamily: 'Poppins',
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                lineHeight: 1.5,
                                                padding: '8px 12px',
                                              },
                                            },
                                          }}
                                        >
                                          <span>
                                            <input
                                              type="checkbox"
                                              checked={forwardOfferCheckList.includes(
                                                checkboxId
                                              )}
                                              disabled={isDisabled}
                                              onChange={(e) => {
                                                e.stopPropagation();

                                                if (
                                                  StageTwo &&
                                                  row?.isUnhandled
                                                ) {
                                                  handleStage2PopupOpen(
                                                    buyerId
                                                  );
                                                  return;
                                                }

                                                setForwardOfferCheckList(
                                                  (prev) =>
                                                    e.target.checked
                                                      ? [...prev, checkboxId]
                                                      : prev.filter(
                                                          (id) =>
                                                            id !== checkboxId
                                                        )
                                                );
                                              }}
                                            />
                                          </span>
                                        </Tooltip>
                                      </Typography>
                                    );
                                  })()}

                                {vendorstatustable &&
                                  !vendorside &&
                                  !forwardbuyernotify &&
                                  !StageTwo && (
                                    <Typography
                                      style={{ padding: '20px 5px 20px 10px' }}
                                    >
                                      <input
                                        type="checkbox"
                                        color="primary"
                                        checked={forwardOfferCheckList.includes(
                                          propertyOfferBuyerId
                                        )}
                                        inputProps={{
                                          'aria-labelledby': labelId,
                                        }}
                                        onClick={(e) => {
                                          setTableChecked(false);
                                          const checkbox = e.target;
                                          const userId = propertyOfferBuyerId;

                                          if (checkbox.checked) {
                                            setForwardOfferCheckList([
                                              ...forwardOfferCheckList,
                                              propertyOfferBuyerId,
                                            ]);
                                          } else {
                                            const index =
                                              forwardOfferCheckList.indexOf(
                                                propertyOfferBuyerId
                                              );
                                            if (index !== -1) {
                                              setForwardOfferCheckList(
                                                forwardOfferCheckList
                                                  .slice(0, index)
                                                  .concat(
                                                    forwardOfferCheckList.slice(
                                                      index + 1
                                                    )
                                                  )
                                              );
                                            }
                                          }
                                        }}
                                      />
                                    </Typography>
                                  )}
                                {!vendorstatustable &&
                                  !vendorside &&
                                  !forwardtootherbuyerstatus && (
                                    <Typography
                                      style={{ padding: '20px 5px 20px 10px' }}
                                    >
                                      <input
                                        type="checkbox"
                                        color="primary"
                                        checked={
                                          (showBackdrop && isCardSelected) ||
                                          buyerRegisterCheckBox.includes(
                                            row?.buyerDetails?.user?.userId
                                          )
                                        }
                                        onClick={() => {
                                          selectCheckBox(
                                            row?.buyerDetails?.user?.userId,
                                            'updateId'
                                          );
                                          setSelectedCheckboxes((prev) =>
                                            prev.includes(
                                              row?.buyerDetails?.user?.userId
                                            )
                                              ? prev.filter(
                                                  (id) =>
                                                    id !==
                                                    row?.buyerDetails?.user
                                                      ?.userId
                                                )
                                              : [
                                                  ...prev,
                                                  row?.buyerDetails?.user
                                                    ?.userId,
                                                ]
                                          );
                                        }}
                                        inputProps={{
                                          'aria-labelledby': labelId,
                                        }}
                                      />
                                    </Typography>
                                  )}
                                {vendorside && !vendorstatustable && (
                                  <Typography
                                    style={{ padding: '20px 5px 20px 10px' }}
                                  >
                                    <input
                                      type="checkbox"
                                      color="primary"
                                      inputProps={{
                                        'aria-labelledby': labelId,
                                      }}
                                    />
                                  </Typography>
                                )}
                              </TableCell>
                              <TableCell
                                component="th"
                                id={labelId}
                                scope="row"
                                padding="none"
                                sx={{
                                  width: StageTwo
                                    ? ' 17%'
                                    : vendorside
                                    ? '17%'
                                    : '9%',
                                }}
                              >
                                <Typography sx={userDetCont}>
                                  <Typography sx={imageCont}>
                                    {!vendorside && (
                                      <Typography
                                        sx={displayFlex}
                                        style={{
                                          justifyContent: 'center',
                                          position: 'relative',
                                          alignItems: 'center',
                                          paddingRight: '10px',
                                        }}
                                      >
                                        <CircularProgressWithProfile
                                          value={
                                            row?.buyerDetails?.profileActivity
                                          }
                                          profileImage={
                                            row?.buyerDetails?.user?.userProfile
                                          }
                                          name={
                                            row?.buyerDetails?.user?.userName?.charAt(
                                              0
                                            ) +
                                            row?.buyerDetails?.user?.userSurName?.charAt(
                                              0
                                            )
                                          }
                                        />
                                      </Typography>
                                    )}
                                    {vendorside && (
                                      <Typography
                                        sx={displayFlex}
                                        style={{
                                          justifyContent: 'center',
                                          position: 'relative',
                                          alignItems: 'center',
                                          paddingRight: '10px',
                                        }}
                                      >
                                        <CircularProgressWithProfileVendor
                                          value={
                                            row?.buyerDetails?.profileActivity
                                          }
                                          name={
                                            row?.buyerDetails?.user?.userName.charAt(
                                              0
                                            ) +
                                            row?.buyerDetails?.user?.userSurName.charAt(
                                              0
                                            )
                                          }
                                        />
                                      </Typography>
                                    )}
                                    {vendorstatustable &&
                                      !vendorside &&
                                      !StageTwo && (
                                        <Typography
                                          sx={
                                            (displayFlex, { cursor: 'pointer' })
                                          }
                                          aria-describedby={props.id}
                                        >
                                          <Typography
                                            sx={{
                                              ...poppins400,
                                              fontSize: '12px',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {row?.buyerDetails?.user?.userName}
                                          </Typography>
                                        </Typography>
                                      )}
                                    {vendorstatustable &&
                                      !vendorside &&
                                      StageTwo && (
                                        <Typography
                                          sx={
                                            (displayFlex, { cursor: 'pointer' })
                                          }
                                          aria-describedby={props.id}
                                        >
                                          <Typography
                                            sx={{
                                              ...poppins400,
                                              fontSize: '12px',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {`${row?.buyerDetails?.user?.userName} ${row?.buyerDetails?.user?.userSurName}`}
                                          </Typography>
                                        </Typography>
                                      )}
                                    {!vendorstatustable && vendorside && (
                                      <Typography
                                        sx={
                                          (displayFlex, { cursor: 'pointer' })
                                        }
                                        aria-describedby={props.id}
                                      >
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            fontSize: '12px',
                                            cursor: 'default',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          <span
                                            style={{
                                              textTransform: 'capitalize',
                                            }}
                                          >
                                            {row?.buyerDetails?.user?.userName}
                                          </span>
                                          &nbsp;
                                          {row?.buyerDetails?.user?.userSurName
                                            ?.charAt(0)
                                            .toUpperCase()}
                                        </Typography>
                                      </Typography>
                                    )}
                                    {forwardtootherbuyerstatus && (
                                      <Typography
                                        sx={
                                          (displayFlex, { cursor: 'pointer' })
                                        }
                                        aria-describedby={props.id}
                                      >
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            fontSize: '12px',
                                            cursor: 'pointer',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {`${row?.buyerDetails?.user?.userName} ${row?.buyerDetails?.user?.userSurName}`}
                                        </Typography>
                                      </Typography>
                                    )}
                                    {!vendorstatustable &&
                                      !vendorside &&
                                      !forwardtootherbuyerstatus && (
                                        <Typography
                                          sx={
                                            (displayFlex,
                                            {
                                              cursor: 'pointer',
                                              position: 'relative',
                                              width: '180px',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                              display: 'inline-block',
                                            })
                                          }
                                          aria-describedby={props.id}
                                          onClick={() =>
                                            handleClickBuyer(
                                              buyerId,
                                              userType,
                                              row
                                            )
                                          }
                                        >
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              width: '100%',
                                              minWidth: 0,
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                flex: '1 1 0',
                                                minWidth: 0,
                                                overflow: 'hidden',
                                              }}
                                            >
                                              <NameTooltip
                                                name={
                                                  row?.buyerDetails?.user
                                                    ?.userName || ''
                                                }
                                                surname={
                                                  row?.buyerDetails?.user
                                                    ?.userSurName || ''
                                                }
                                              >
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    fontSize: '12px',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    color: '#112347',
                                                    display: 'block',
                                                  }}
                                                  onClick={(event) => {
                                                    handleClickBuyer(
                                                      buyerId,
                                                      userType,
                                                      row
                                                    );
                                                    setShowBackDrop(false);
                                                    collectId(
                                                      tableData,
                                                      buyerId,
                                                      setBuyerId,
                                                      setPosition,
                                                      setArrayCollection
                                                    );
                                                  }}
                                                >
                                                  {`${
                                                    row?.buyerDetails?.user
                                                      ?.userName || ''
                                                  } ${
                                                    row?.buyerDetails?.user
                                                      ?.userSurName || ''
                                                  }`.trim()}
                                                </Typography>
                                              </NameTooltip>
                                            </Box>

                                            {!vendorside && (
                                              <>
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexShrink: 0,
                                                  }}
                                                >
                                                  {BuyerDropdown != index ? (
                                                    <IconButton
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setBuyerDropdown(index);
                                                      }}
                                                    >
                                                      <UserNameDownArrow />
                                                    </IconButton>
                                                  ) : (
                                                    <IconButton
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setBuyerDropdown(null);
                                                      }}
                                                    >
                                                      <UserNameUpArrow />
                                                    </IconButton>
                                                  )}
                                                </Box>
                                                {row?.buyerOfferDetails
                                                  ?.isWinner == 1 && (
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      flexShrink: 0,
                                                    }}
                                                  >
                                                    <TrophyIcon />
                                                  </Box>
                                                )}
                                              </>
                                            )}
                                          </Box>

                                          {BuyerDropdown == index && (
                                            <Stack
                                              direction={'row'}
                                              justifyContent={'left'}
                                              position={'absolute'}
                                              style={{
                                                bottom: '-28px',
                                                left: '0',
                                                minWidth: '120px',
                                                gap: '10px',
                                              }}
                                            >
                                              <Avatar
                                                alt=""
                                                src={BlueTick}
                                                size={'small'}
                                                sx={{
                                                  height: '5px',
                                                  width: '5px',
                                                }}
                                              />
                                              <Avatar
                                                alt=""
                                                size={'small'}
                                                src={Monetize}
                                                sx={{
                                                  height: '5px',
                                                  width: '5px',
                                                }}
                                              />
                                            </Stack>
                                          )}
                                        </Typography>
                                      )}
                                  </Typography>
                                </Typography>
                              </TableCell>
                              {!vendorside && (
                                <TableCell
                                  align="left"
                                  sx={{ width: StageTwo && '10%' }}
                                >
                                  {
                                    <Contact
                                      row={row?.buyerDetails}
                                      directcomm={directcomm}
                                      index={null}
                                    />
                                  }
                                </TableCell>
                              )}
                              {!buyeroffer && !vendorside && (
                                <TableCell
                                  align="center"
                                  aria-describedby={idBuyer}
                                  id={idBuyer}
                                >
                                  <Box
                                    onClick={(event) =>
                                      buyerReadiness(
                                        event,
                                        row?.buyerDetails?.rediness,
                                        row?.buyerDetails?.user?.userName,
                                        row?.buyerDetails?.user?.userSurName
                                      )
                                    }
                                    sx={{
                                      width: '130px',
                                      height: '16px',
                                      position: 'relative',
                                      borderRadius: '2.42px',
                                      background: 'transparent',
                                      overflow: 'hidden',
                                      cursor: 'pointer',
                                      isolation: 'isolate',
                                      '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        inset: 0,
                                        borderRadius: '2.42px',
                                        padding: '1.5px',
                                        background:
                                          'linear-gradient(90deg, #77CFFE, #6C2AD2)',
                                        WebkitMask:
                                          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                        WebkitMaskComposite: 'xor',
                                        maskComposite: 'exclude',
                                        pointerEvents: 'none',
                                      },
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        position: 'absolute',
                                        inset: '1px',
                                        borderRadius: '1px',
                                        overflow: 'hidden',
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: `${
                                            row?.buyerDetails?.rediness || 0
                                          }%`,
                                          height: '100%',
                                          background:
                                            'linear-gradient(90deg, #77CFFE 0%, #6C2AD2 100%)',
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{
                                        position: 'absolute',
                                        inset: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '10px',
                                        fontFamily: 'poppins',
                                        color: textColor,
                                        fontWeight: 500,
                                        pointerEvents: 'none',
                                      }}
                                    >
                                      {Math.round(
                                        row?.buyerDetails?.rediness || 0
                                      )}
                                      %
                                    </Box>
                                  </Box>
                                </TableCell>
                              )}
                              {!vendorside && (
                                <TableCell align="center" sx={{ width: '10%' }}>
                                  {pendingTable ? (
                                    <Typography
                                      sx={{
                                        ...poppins400,
                                        ...fontsize14,
                                        textAlign: 'left',
                                      }}
                                    >
                                      -
                                    </Typography>
                                  ) : (
                                    <Stack direction={'row'} spacing={2}>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          cursor:
                                            row?.buyerDetails?.is66Signed == 0
                                              ? 'default'
                                              : 'pointer',
                                        }}
                                        onClick={() => {
                                          if (
                                            row?.buyerDetails?.is66Signed !==
                                              0 &&
                                            row?.signed66WFile
                                          ) {
                                            handleOpen66WDialog(row);
                                          }
                                        }}
                                      >
                                        <Typography
                                          textAlign={'left'}
                                          sx={{ pointerEvents: 'none' }}
                                        >
                                          {row?.buyerDetails?.is66Signed ==
                                          0 ? (
                                            <GreyPaper />
                                          ) : (
                                            <ColorPaper />
                                          )}
                                        </Typography>
                                        <Typography
                                          style={{
                                            fontFamily: 'Poppins',
                                            fontSize: '9.69px',
                                            fontWeight: '400px',
                                            color:
                                              row?.buyerDetails?.is66Signed ===
                                              0
                                                ? '#707b91'
                                                : '#6C2AD2',
                                          }}
                                        >
                                          {'s66W'}
                                        </Typography>
                                      </Box>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          cursor:
                                            row?.buyerOfferDetails == ''
                                              ? null
                                              : 'pointer',
                                        }}
                                        onClick={() => {
                                          if (row?.buyerOfferDetails != '') {
                                            setSelectedrowbuyername(
                                              row?.buyerDetails?.user
                                                ?.userName +
                                                ' ' +
                                                row?.buyerDetails?.user
                                                  ?.userSurName
                                            );
                                            setbuyerOfferPrice(
                                              row?.buyerOfferDetails?.offerPrice
                                            );
                                            setSelectedrowbuyerid(
                                              row?.buyerDetails?.user?.userId
                                            );
                                            if (row?.isDepositReceived == 1) {
                                              setDepositdetails(true);
                                              setManageofferrow(row);
                                            } else {
                                              setRequestdeposit(true);
                                              setManageofferrow(row);
                                            }
                                            setDepositRes(
                                              row?.buyerOfferDetails
                                                ?.depositPaymentLog
                                            );
                                            setSelectedrow(row);
                                            setBuyerId(
                                              row?.buyerDetails?.user?.userId
                                            );
                                          }
                                        }}
                                      >
                                        <Typography>
                                          {row?.logDepPayData == 0 ? (
                                            <RequestIcon color={'#CACACA'} />
                                          ) : (
                                            <RequestIcon color={'#6A2BCF'} />
                                          )}
                                        </Typography>
                                        <Typography
                                          style={{
                                            fontFamily: 'Poppins',
                                            fontSize: '9.69px',
                                            fontWeight: '400px',
                                            color:
                                              row?.logDepPayData == 0
                                                ? '#707b91'
                                                : '#6C2AD2',
                                          }}
                                        >
                                          {'Request'}
                                        </Typography>
                                      </Box>
                                    </Stack>
                                  )}
                                </TableCell>
                              )}
                              <TableCell
                                align="left"
                                sx={{ width: vendorside ? '20%' : '10%' }}
                              >
                                {
                                  <OfferContainer
                                    row={row}
                                    data={row?.buyerOfferDetails?.offerPrice}
                                    agentReg={true}
                                    offerIsFinal={
                                      row?.buyerOfferDetails?.offerIsFinal
                                    }
                                    userTypeValue={userTypeValue}
                                    isMarket={row?.buyerOfferDetails?.isMarket}
                                    propertyDetails={propertyDetails}
                                    index={index}
                                    pendingTable={pendingTable}
                                  />
                                }
                              </TableCell>
                              <TableCell
                                sx={{
                                  ...poppins400,
                                  fontSize: '14px',
                                  width: '10%',
                                }}
                                align="left"
                              >
                                {pendingTable
                                  ? '-'
                                  : row?.buyerDetails?.noOfOffers}
                              </TableCell>
                              {!buyeroffer && !StageTwo && (
                                <>
                                  <TableCell
                                    align="center"
                                    sx={{ width: vendorside ? '15%' : '10%' }}
                                  >
                                    {pendingTable ||
                                    row?.buyerDetails?.rating == 0 ? (
                                      <Typography
                                        sx={{
                                          ...poppins400,
                                          ...fontsize14,
                                          textAlign: 'left',
                                        }}
                                      >
                                        -
                                      </Typography>
                                    ) : (
                                      <Typography
                                        id={idProperty}
                                        component="div"
                                        onClick={(event) =>
                                          propertyProgress(
                                            row?.buyerDetails?.interestedAvg,
                                            row?.buyerDetails?.rating,
                                            event,
                                            row?.buyerDetails?.user?.userName,
                                            row?.buyerDetails?.user?.userSurName
                                          )
                                        }
                                        sx={displayFlex}
                                        style={{
                                          justifyContent: 'center',
                                          position: 'relative',
                                          alignItems: 'center',
                                          cursor: 'pointer',
                                        }}
                                      >
                                        <CircularProgressWithLabel
                                          value={
                                            row?.buyerDetails?.interestedAvg
                                          }
                                          rating={row?.buyerDetails?.rating}
                                        />
                                        <CircularProgress
                                          value={100}
                                          variant="determinate"
                                          sx={{
                                            position: 'absolute',
                                            color: '#C4C4C461',
                                            ...poppins500,
                                            fontSize: '14px',
                                          }}
                                          thickness={5}
                                          size={45}
                                        />
                                      </Typography>
                                    )}
                                  </TableCell>
                                  <TableCell align="left">
                                    {pendingTable ? (
                                      <Typography
                                        sx={{
                                          ...poppins400,
                                          ...fontsize14,
                                          textAlign: 'left',
                                        }}
                                      >
                                        -
                                      </Typography>
                                    ) : row?.buyerDetails?.exp ? (
                                      <Typography
                                        id={idExp}
                                        display="flex"
                                        alignItems="center"
                                        textAlign="left"
                                        onClick={(event) =>
                                          buyerExp(
                                            event,
                                            row?.buyerDetails?.user?.userName,
                                            row?.buyerDetails?.exp,
                                            row?.buyerDetails?.user?.userSurName
                                          )
                                        }
                                        style={{
                                          cursor: 'pointer',
                                        }}
                                      >
                                        <ExpIcon />
                                        <Typography
                                          style={{
                                            width: '19.13px',
                                            height: '19.13px',
                                            backgroundColor: '#F64646',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#FFFFFF',
                                            fontFamily: 'Poppins',
                                            fontSize: '12.92px',
                                          }}
                                        >
                                          {row?.buyerDetails?.exp}
                                        </Typography>
                                      </Typography>
                                    ) : (
                                      <Typography sx={{ textAlign: 'left' }}>
                                        -
                                      </Typography>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    sx={{ width: vendorside && '10%' }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      alignItems={'center'}
                                      justifyContent={'left'}
                                    >
                                      {pendingTable ? (
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            ...fontsize14,
                                            textAlign: 'left',
                                          }}
                                        >
                                          -
                                        </Typography>
                                      ) : row?.buyerDetails?.profile != '' ? (
                                        <>
                                          <Typography
                                            component="div"
                                            id={idProperty}
                                            onClick={(event) =>
                                              buyerProfile(
                                                event,
                                                row?.buyerDetails?.user
                                                  ?.userName,
                                                row?.buyerDetails?.profile,
                                                row?.buyerDetails?.user
                                                  ?.userSurName
                                              )
                                            }
                                            sx={{
                                              ...poppins400,
                                              fontSize: '13px',
                                              marginRight: '10px',
                                              fontWeight: 400,
                                              cursor: 'pointer',
                                              color: '#112347',
                                            }}
                                          >
                                            {row?.buyerDetails?.profile}
                                          </Typography>
                                        </>
                                      ) : (
                                        <Grid item>
                                          <Typography textAlign={'center'}>
                                            {'-'}
                                          </Typography>
                                        </Grid>
                                      )}
                                    </Stack>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Stack
                                      direction={'row'}
                                      alignItems={'center'}
                                      justifyContent={'center'}
                                      sx={{
                                        width: matchessm ? 'auto' : '135px',
                                      }}
                                    >
                                      {pendingTable ? (
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            ...fontsize14,
                                            textAlign: 'left',
                                          }}
                                        >
                                          -
                                        </Typography>
                                      ) : row?.buyerOfferDetails != '' ? (
                                        <>
                                          <Grid
                                            container
                                            sx={{
                                              dsiplay: 'flex',
                                              flexDirection: 'column',
                                              gap: '15px',
                                            }}
                                          >
                                            <Grid
                                              item
                                              onClick={() => {
                                                setManageofferrow(row);
                                                setManageOffer(true);
                                              }}
                                              sx={{ cursor: 'pointer' }}
                                            >
                                              <div>
                                                <BadgeButton
                                                  row={row}
                                                  offerStatus={
                                                    row?.buyerOfferDetails
                                                      ?.offerStatus
                                                  }
                                                  offerStatusVendor={
                                                    row?.buyerOfferDetails
                                                      ?.offerStatusVendor
                                                  }
                                                  isnew={
                                                    row?.buyerOfferDetails
                                                      ?.isNew
                                                  }
                                                  offerStatusCode={
                                                    row?.buyerOfferDetails
                                                      ?.offerStatusCode
                                                  }
                                                />
                                              </div>
                                            </Grid>
                                            {!row?.buyerOfferDetails
                                              ?.offerStatusVendor ||
                                              (row?.buyerOfferDetails
                                                ?.offerStatusVendor !==
                                                null && (
                                                <Grid
                                                  item
                                                  onClick={() => {
                                                    setManageofferrow(row);
                                                    setManageOffer(true);
                                                    setisVendorHistoryId(true);
                                                  }}
                                                  sx={{ cursor: 'pointer' }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      padding: '3px 10px',
                                                      border: `1px solid ${getColor(
                                                        row?.buyerOfferDetails
                                                          ?.offerStatusVendor
                                                      )}`,
                                                      borderRadius: '17px',
                                                      width: '135px',
                                                      flexWrap: 'nowrap',
                                                      whiteSpace: 'nowrap',
                                                      fontFamily:
                                                        'Poppins !important',
                                                      fontStyle:
                                                        'normal !important',
                                                      fontWeight:
                                                        '300 !important',
                                                      fontSize:
                                                        '12px !important',
                                                      color: getColor(
                                                        row?.buyerOfferDetails
                                                          ?.offerStatusVendor
                                                      ),
                                                      justifyContent: 'center',
                                                      alignItems: 'center',
                                                      display: 'flex',
                                                      gap: 0.5,
                                                    }}
                                                  >
                                                    <WarningLite
                                                      color={getColor(
                                                        row?.buyerOfferDetails
                                                          ?.offerStatusVendor
                                                      )}
                                                    />
                                                    {
                                                      row?.buyerOfferDetails
                                                        ?.offerStatusVendor
                                                    }
                                                  </Typography>
                                                </Grid>
                                              ))}
                                          </Grid>
                                        </>
                                      ) : (
                                        <Grid item>
                                          <Typography textAlign={'left'}>
                                            {'-'}
                                          </Typography>
                                        </Grid>
                                      )}
                                    </Stack>
                                  </TableCell>
                                  <TableCell align="right">
                                    <Stack
                                      direction={'row'}
                                      spacing={vendorside ? 3 : 1}
                                      alignItems="center"
                                    >
                                      {/* Fixed width container for Feedback button */}
                                      <Box sx={{ width: '90px' }}>
                                        {' '}
                                        {/* Adjust width as needed */}
                                        {!pendingTable &&
                                          userType1 == 'Agent' && (
                                            <Button
                                              sx={{
                                                ...poppins400,
                                                boxShadow: 'none',
                                                fontSize: '14px',
                                                color: '#6C2AD2',
                                                bgcolor:
                                                  'rgba(108, 42, 210, 0.1)',
                                                minWidth: '80px', // Fixed minimum width
                                              }}
                                              onClick={() => {
                                                setUserEmail(
                                                  row?.buyerDetails?.userEmail
                                                );
                                                setUserType(
                                                  row?.buyerDetails
                                                    ?.userCategory[0]?.userType
                                                );
                                                setBuyerId(
                                                  row?.buyerDetails?.user
                                                    ?.userId
                                                );
                                                setUserName(
                                                  row?.buyerDetails?.user
                                                    ?.userName +
                                                    ' ' +
                                                    row?.buyerDetails?.user
                                                      ?.userSurName
                                                );
                                                setOpenFeedback(true);
                                                setFeedBackData(row);
                                                setUserInitial(
                                                  `${
                                                    row?.buyerDetails?.user?.userName
                                                      ?.trim()
                                                      ?.charAt(0) || ''
                                                  }${
                                                    row?.buyerDetails?.user?.userSurName
                                                      ?.trim()
                                                      ?.charAt(0) || ''
                                                  }`.toUpperCase()
                                                );
                                              }}
                                            >
                                              Feedback
                                            </Button>
                                          )}
                                      </Box>

                                      {/* 3-dot menu - always in the same position */}
                                      {!vendorside && (
                                        <div
                                          style={{
                                            opacity: showPendingTable ? 0.5 : 1,
                                            pointerEvents: showPendingTable
                                              ? 'none'
                                              : 'auto',
                                          }}
                                        >
                                          <SelectMenu
                                            setManageofferrow={
                                              setManageofferrow
                                            }
                                            setBuyerRegisterChecked={
                                              setBuyerRegisterChecked
                                            }
                                            index={index}
                                            setBuyerRegisterCheckBox={
                                              setBuyerRegisterCheckBox
                                            }
                                            buyerRegisterCheckBoxArr={
                                              buyerRegisterCheckBoxArr
                                            }
                                            buyerRegisterCheckBox={
                                              buyerRegisterCheckBox
                                            }
                                            buyerId={buyerId}
                                            onShowChat={onShowChat}
                                            setOpenBox={setOpenBox}
                                            openBox={openBox}
                                            setOfferUniqueId={setOfferUniqueId}
                                            setPaymentStatus={setPaymentStatus}
                                            offerUniqueId={offerUniqueId}
                                            row={row}
                                            tableData={propertyDetails}
                                            forwardtobuyer={forwardtobuyer}
                                            setbuyerOfferPrice={
                                              setbuyerOfferPrice
                                            }
                                            selectedrowbuyerid={
                                              selectedrowbuyerid
                                            }
                                            setSelectedrowbuyerid={
                                              setSelectedrowbuyerid
                                            }
                                            setOpenPublishWinnerBox={
                                              setOpenPublishWinnerBox
                                            }
                                            setTableChecked={setTableChecked}
                                            tableChecked={tableChecked}
                                            setForwardtobuyer={
                                              setForwardtobuyer
                                            }
                                            updatefunc={updatefunc}
                                            getListInfo={getListInfo}
                                            address={address}
                                            profileData={propertyDetails}
                                            buyerRegisterChecked={
                                              buyerRegisterChecked
                                            }
                                            handleClick={handleClick}
                                            setShowBackDrop={setShowBackDrop}
                                            isCardSelected={isCardSelected}
                                            setSelectedrowbuyername={
                                              setSelectedrowbuyername
                                            }
                                            selectedrowbuyername={
                                              selectedrowbuyername
                                            }
                                            buyerOfferPrice={buyerOfferPrice}
                                            setOfferHistory={setOfferHistory}
                                            offerHistory={offerHistory}
                                            userTypeValue={userTypeValue}
                                            reqDepositOpen={reqDepositOpen}
                                            setReqDepositOpen={
                                              setReqDepositOpen
                                            }
                                            campaignId={
                                              propertyDetails?.PropertyDetails
                                                ?.campaignId
                                            }
                                            selectedCheckboxes={
                                              buyerRegisterCheckBox
                                            }
                                            setSelectedCheckboxes={
                                              setSelectedCheckboxes
                                            }
                                            setBuyerRegisterCheckBoxArr={
                                              setBuyerRegisterCheckBoxArr
                                            }
                                            {...props}
                                            endPropertyPopupFromNominateWinner={
                                              endPropertyPopupFromNominateWinner
                                            }
                                            setEndPropertyPopupFromNominateWinner={
                                              setEndPropertyPopupFromNominateWinner
                                            }
                                            latestcounterOfferPrice={
                                              propertyDetails?.latestcounterOfferPrice
                                            }
                                            sharedToMarket={sharedToMarket}
                                          />
                                        </div>
                                      )}

                                      {vendorside && (
                                        <VendorSelectMenu
                                          row={row}
                                          setVendorAction={setVendorAction}
                                          setItemObj={setItemObj}
                                          acceptLog={
                                            propertyDetails?.PropertyDetails
                                              ?.isAcceptedLog
                                          }
                                          propertyId={propertyId}
                                          getListInfo={getListInfo}
                                          buyerId={buyerId}
                                          onShowChat={onShowChat}
                                          forwardBuyersOfferToOtherBuyers={
                                            forwardBuyersOfferToOtherBuyers
                                          }
                                          tableData={propertyDetails}
                                          vendorside={vendorside}
                                          vendorDatas={vendorDatas}
                                          setIsSwalOpen={setIsSwalOpen}
                                          setVendorGeneratePdf={
                                            setVendorGeneratePdf
                                          }
                                        />
                                      )}
                                    </Stack>
                                  </TableCell>
                                </>
                              )}
                            </TableRow>

                            {!vendorside && (
                              <TableDropdown
                                tableData={tableData}
                                BuyerDropdown={BuyerDropdown}
                                propertyDetails={propertyDetails}
                                index={index}
                                row={row}
                                key={index}
                                CircularProgressWithProfile={
                                  CircularProgressWithProfile
                                }
                                directcomm={directcomm}
                                buyerData={row}
                                userDetail={userDetail}
                                onShowChat={onShowChat}
                              />
                            )}
                          </>
                        );
                      }
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colspan={12}
                        sx={{
                          textAlign: 'center',
                          fontFamily: 'poppins',
                          fontWeight: 400,
                          fontSize: '10px',
                        }}
                      >
                        Buyer Not Available
                      </TableCell>
                    </TableRow>
                  )}

                  {(manageOffer ||
                    openhistorydialog ||
                    openManageOfferFromVendorStatus.open) && (
                    <ManageOffer
                      offerUniqueId={
                        manageofferrow?.buyerOfferDetails?.offerUniqueId
                      }
                      buyerId={
                        openManageOfferFromVendorStatus.open
                          ? openManageOfferFromVendorStatus?.buyerId
                          : manageofferrow?.buyerOfferDetails
                              ?.propertyOfferBuyerId
                      }
                      open={manageOffer || openManageOfferFromVendorStatus.open}
                      onClose={manageOfferClickClose}
                      manageOffer={manageOffer}
                      setManageOffer={setManageOffer}
                      setOpenhistorydialog={setOpenhistorydialog}
                      getListInfo={getListInfo}
                      updatefunc={updatefunc}
                      offerIsFinal={
                        manageofferrow?.buyerOfferDetails?.offerIsFinal
                      }
                      agentSubText={true}
                      row={manageofferrow}
                      userTypeValue={userTypeValue}
                      badgebtnManageOffer={true}
                      isVendorHistoryId={isVendorHistoryId}
                      tableData={tableData}
                      setisVendorHistoryId={setisVendorHistoryId}
                      onShowChat={onShowChat}
                      vendorDatas={vendorDatas}
                      setIsSwalOpen={setIsSwalOpen}
                      setVendorGeneratePdf={setVendorGeneratePdf}
                    />
                  )}

                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: 53 * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <Dialog
            open={finalContract}
            PaperProps={{
              sx: {
                borderRadius: '5px',
                minWidth: matchessm ? '100%' : '400px',
                boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                padding: '25px',
              },
            }}
          >
            <Grid container height={'100%'}>
              <Grid item md={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '18px',
                    color: '#666666',
                  }}
                >
                  Do you want to upload final contract file to this buyer ?
                </Typography>
              </Grid>

              <Grid
                item
                container
                direction="row"
                justifyContent={matchessm ? 'center' : 'flex-end'}
                gap={2}
                marginTop={5}
              >
                <Grid item>
                  <Button
                    variant="outlined"
                    style={{
                      padding: '10px 39px',
                      width: '100%',
                      height: '41px',
                      fontSize: '14px',
                      color: '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(17, 35, 71, 0.1)',
                      borderRadius: '5px',
                    }}
                    onClick={handleClickCloseFinal}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      openMessage(binderID);
                    }}
                    style={{
                      padding: '10px 39px',
                      width: '100%',
                      height: '41px',
                      fontSize: '14px',
                      color: '#FFFFFF',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      background: '#4CA4D6',
                      borderRadius: '5px',
                    }}
                  >
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Dialog>

          {requestdeposit && (
            <Requestdeposit
              requestdeposit={requestdeposit}
              endPropertyPopupFromNominateWinner={
                endPropertyPopupFromNominateWinner
              }
              setRequestdeposit={setRequestdeposit}
              setReqDepositOpen={setReqDepositOpen}
              manageOfferClick={manageOfferClick}
              selectedrowbuyerid={selectedrowbuyerid}
              getListInfo={getListInfo}
              selectedrowbuyername={selectedrowbuyername}
              row={manageofferrow}
              reqDepositOpen={reqDepositOpen}
              address={address}
              depositRes={depositRes}
              setEndPropertyPopupFromNominateWinner={
                setEndPropertyPopupFromNominateWinner
              }
              profileDetails={propertyDetails}
              setSelectedrow={setSelectedrow}
              fromTable={true}
            />
          )}
          {depositdetails && (
            <DetailsPopup
              openDetailsPopup={depositdetails}
              handleCloseDetails={() => {
                setDepositdetails(false);
              }}
              profileDetails={propertyDetails}
              buyerId={buyerId}
              isFromBuyerRegister={true}
              getListInfo={getListInfo}
              manageOfferClick={manageOfferClick}
            />
          )}

          <Popover
            id={idBuyer}
            open={openBuyer}
            anchorEl={anchorElBuyer}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                maxWidth: '540px',
                marginTop: '-20px',
              }}
            >
              <Grid sx={{ padding: '0 30px', marginTop: '50px' }}>
                <Typography
                  sx={{
                    color: '#6C2AD2',
                    fontFamily: 'poppins',
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                >
                  Buyer Readiness
                </Typography>
              </Grid>
              <Grid sx={{ padding: '0 30px' }}>
                <Typography
                  sx={{
                    color: '#112347',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 300,
                  }}
                >
                  The Buyer readiness indicator measures and displays the
                  progress of a buyer on their individual journey in relation to
                  administrative preparation and research.
                </Typography>
              </Grid>
              <Grid sx={{ padding: '0 30px' }}>
                <Typography
                  sx={{
                    color: '#112347',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 300,
                  }}
                >
                  Most buyers of properties similar to{' '}
                  <span style={{ fontWeight: 600 }}>
                    {
                      propertyDetails?.PropertyDetails?.propertyAddress
                        ?.propertyNo
                    }{' '}
                    {
                      propertyDetails?.PropertyDetails?.propertyAddress
                        ?.streetName
                    }{' '}
                  </span>
                  , purchase once readiness of 82% or above has been reached.
                </Typography>
              </Grid>

              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ maxWidth: '100%', padding: '0px 30px' }}
              >
                <Grid
                  item
                  xs={3}
                  sx={{
                    minWidth: 0,
                    overflow: 'hidden',
                  }}
                >
                  <NameTooltip
                    name={buyerName || ''}
                    surname={buyerSurName || ''}
                  >
                    <Typography
                      sx={{
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 600,
                        display: 'block',
                        width: '100%',
                        minWidth: 0,
                        maxWidth: '100%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        cursor: 'pointer',
                      }}
                    >
                      {`${buyerName || ''} ${buyerSurName || ''}`.trim()}
                    </Typography>
                  </NameTooltip>
                </Grid>
                <Grid item xs={8.5} sx={{ position: 'relative' }}>
                  {/* Gradient border wrapper */}
                  <Box
                    sx={{
                      position: 'relative',
                      padding: '2px',
                      background: 'linear-gradient(90deg, #77CFFE, #6C2AD2)',
                      borderRadius: '5px',
                    }}
                  >
                    <Box sx={{ background: '#FFFFFF', borderRadius: '3px' }}>
                      <BorderLinearProgress
                        sx={{
                          height: 35,
                          '& .MuiLinearProgress-bar': {
                            background:
                              'linear-gradient(90deg, #77CFFE 0%, #6C2AD2 100%)',
                          },
                          '&.MuiLinearProgress-colorPrimary': {
                            border: 'none',
                          },
                        }}
                        variant="determinate"
                        value={buyerReadinessValue}
                      />
                    </Box>
                  </Box>
                  <TextOverlay
                    sx={{
                      color: textColor,
                      fontSize: '14px',
                      fontWeight: 400,
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                      zIndex: 2,
                    }}
                    variant="body2"
                    color="textSecondary"
                  >
                    {`${Math.round(buyerReadinessValue)}%`}
                  </TextOverlay>
                  <Box sx={{ position: 'absolute', left: '80%', top: '-10px' }}>
                    <StraightLine />
                  </Box>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    fontFamily: 'poppins',
                    marginRight: '25%',
                  }}
                >
                  Market Average ( 80% )
                </Typography>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems={'center'}
                  sx={{
                    borderTop: '1px solid lightgrey',
                    padding: '15px 20px',
                    fontFamily: 'poppins',
                    marginTop: '15px',
                  }}
                >
                  <Grid>
                    <Typography
                      onClick={() => {
                        handleCloseBuyer();
                        history.push('/helpcentre');
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 400,
                        margin: 0,
                        cursor: 'pointer',
                      }}
                    >
                      <InfoIcon />
                      Need Help ?
                    </Typography>
                  </Grid>
                  <Grid>
                    <Button
                      onClick={handleCloseBuyer}
                      sx={{
                        padding: '10px 30px',
                        color: 'grey',
                        fontFamily: 'poppins',
                        border: '1px solid lightgrey',
                        textTransform: 'none',
                      }}
                      variant="outlined"
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Popover>

          {/* //Exp Popup Popover */}

          <Popover
            id={idExp}
            open={openExp}
            anchorEl={anchorElExp}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                maxWidth: '540px',
              }}
            >
              <Grid sx={{ padding: '0 30px', marginTop: '20px' }}>
                <Typography
                  sx={{
                    color: '#6C2AD2',
                    fontFamily: 'poppins',
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                >
                  Buyer Experience
                </Typography>
              </Grid>
              <Grid
                container
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0 30px',
                }}
              >
                <Grid
                  xs={12}
                  sm={6.9}
                  sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                >
                  <Grid>
                    <Typography
                      sx={{
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 300,
                      }}
                    >
                      Buyer Experience Level (EXP) indicates the buyer’s
                      familiarity and confidence with the purchase process,
                      based on their current and past experience in the property
                      market.
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      sx={{
                        display: 'inline-block',
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 300,
                        background: '#F8F8F8',
                        padding: '10px',
                      }}
                    >
                      <span style={{ fontWeight: 800 }}>
                        {' '}
                        {buyerName} {buyerSurName}{' '}
                      </span>
                      experience rating
                      <span
                        style={{
                          padding: '3px 9px',
                          background:
                            exp == 'A'
                              ? '#229E45B8'
                              : exp == 'B'
                              ? '2FCDFF9E'
                              : exp == 'C'
                              ? 'FBA729BD'
                              : '#F64646',
                          borderRadius: '50px',
                          color: 'white',
                          marginLeft: '10px',
                        }}
                      >
                        {exp}
                      </span>
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      sx={{
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 300,
                      }}
                    >
                      Most buyers of properties similar to{' '}
                      <span style={{ fontWeight: 600 }}>
                        {
                          propertyDetails?.PropertyDetails?.propertyAddress
                            ?.propertyNo
                        }{' '}
                        {
                          propertyDetails?.PropertyDetails?.propertyAddress
                            ?.streetName
                        }{' '}
                      </span>
                      , purchase with a property rating of or above.
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  xs={12}
                  sm={4.6}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    position: 'relative',
                    marginTop: '5px',
                  }}
                >
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '25px',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <PersonGreen />
                      <Typography
                        style={{
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                          padding: '1px 7px',
                          background: '#229E45B8',
                          borderRadius: '50px',
                          color: 'white',
                          marginLeft: '5px',
                        }}
                      >
                        A
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <PersonBlue />
                      <Typography
                        style={{
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                          padding: '1px 7px',
                          background: '#2FCDFF9E',
                          borderRadius: '50px',
                          color: 'white',
                          marginLeft: '5px',
                        }}
                      >
                        B
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <PersonYellow />
                      <Typography
                        style={{
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                          padding: '1px 7px',
                          background: '#FBA729BD',
                          borderRadius: '50px',
                          color: 'white',
                          marginLeft: '5px',
                        }}
                      >
                        C
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <PersonRed />
                      <Typography
                        style={{
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                          padding: '1px 7px',
                          background: '#F64646',
                          borderRadius: '50px',
                          color: 'white',
                          marginLeft: '5px',
                        }}
                      >
                        D
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid>
                    <LineIndicator />
                    <Typography
                      sx={{
                        fontSize: '12px',
                        position: 'absolute',
                        top: exp == 'A' ? '4%' : '10%',
                        left: '44%',
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                      }}
                    >
                      <DotLine />
                      Market Average
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        position: 'absolute',
                        top:
                          exp == 'A'
                            ? '12%'
                            : exp == 'B'
                            ? '35%'
                            : exp == 'C'
                            ? '60%'
                            : '82%',
                        left: '44%',
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                      }}
                    >
                      <DotLine />
                      {buyerName}
                    </Typography>
                  </Grid>
                  <Grid></Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                justifyContent="space-between"
                alignItems={'center'}
                sx={{
                  borderTop: '1px solid lightgrey',
                  padding: '15px 20px',
                  fontFamily: 'poppins',
                  marginTop: '15px',
                }}
              >
                <Grid>
                  <Typography
                    onClick={() => {
                      handleCloseExp();
                      history.push('/helpcentre');
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      color: '#112347',
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      fontWeight: 400,
                      margin: 0,
                      cursor: 'pointer',
                    }}
                  >
                    <InfoIcon />
                    Need Help ?
                  </Typography>
                </Grid>
                <Grid>
                  <Button
                    onClick={handleCloseExp}
                    sx={{
                      padding: '10px 30px',
                      color: 'grey',
                      fontFamily: 'poppins',
                      border: '1px solid lightgrey',
                      textTransform: 'none',
                    }}
                    variant="outlined"
                  >
                    Close
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Popover>

          {/* //Profile Popup Popover */}
          <Popover
            id={idProfile}
            open={openProfile}
            anchorEl={anchorElProfile}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                maxWidth: '540px',
                marginTop: '-20px',
              }}
            >
              <Grid sx={{ padding: '0 30px', marginTop: '50px' }}>
                <Typography
                  sx={{
                    color: '#6C2AD2',
                    fontFamily: 'poppins',
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                >
                  Buyer Profile
                </Typography>
              </Grid>
              <Grid
                container
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0 30px',
                }}
              >
                <Grid xs={12}>
                  <Grid>
                    <Typography
                      sx={{
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 300,
                      }}
                    >
                      Buyer Profile indicates the type of buyer and their
                      intention with the purchase process, based on their
                      current and past experience in the property market.
                    </Typography>
                    <Grid
                      sx={{
                        marginTop: '10px',
                      }}
                    >
                      <Typography
                        sx={{
                          color: '#112347',
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                        }}
                      >
                        Most buyers of properties similar to{' '}
                        {
                          propertyDetails?.PropertyDetails?.propertyAddress
                            ?.propertyNo
                        }{' '}
                        {
                          propertyDetails?.PropertyDetails?.propertyAddress
                            ?.streetName
                        }{' '}
                        , purchase are:{' '}
                        <span style={{ fontWeight: 600 }}>
                          {buyerProfileStatus}
                        </span>{' '}
                        and <span style={{ fontWeight: 600 }}>INV</span>.
                      </Typography>
                    </Grid>
                    <Grid xs={12} sx={{ margin: '20px auto', width: '80%' }}>
                      <Typography
                        sx={{
                          color: '#112347',
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                          background: '#F8F8F8',
                          padding: '10px',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-around',
                        }}
                      >
                        <span style={{ fontWeight: 800 }}>
                          {' '}
                          {buyerName} {buyerSurName}
                        </span>{' '}
                        <span style={{ fontWeight: 800 }}>
                          {buyerProfileStatus}
                        </span>
                        {buyerProfileStatus == 'FHB'
                          ? 'First Home Buyer'
                          : buyerProfileStatus == 'Reloc'
                          ? 'Re-Locator'
                          : buyerProfileStatus == 'INV'
                          ? 'Investor'
                          : buyerProfileStatus == 'UpSize'
                          ? 'UpSizer'
                          : 'DownSizer'}
                      </Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      onClick={() => {
                        setDetailsShow(!detailsShow);
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#2F74EE',
                        fontWeight: 500,
                        cursor: 'pointer',
                      }}
                    >
                      Details &nbsp;
                      {!detailsShow ? (
                        <KeyboardArrowDownIcon
                          sx={{ color: '#2F74EE', fontWeight: 500 }}
                        />
                      ) : (
                        <KeyboardArrowUpIcon
                          sx={{ color: '#2F74EE', fontWeight: 500 }}
                        />
                      )}
                    </Grid>
                    {detailsShow && (
                      <Grid
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '20px',
                          flexWrap: 'wrap',
                          marginTop: '15px',
                        }}
                      >
                        {[
                          'First Home Buyer',
                          'Re-Locator',
                          'Investor',
                          'UpSizer',
                          'DownSizer',
                        ].map((item) => (
                          <Box sx={{ display: 'flex', gap: '10px' }}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: '15px',
                                fontFamily: 'poppins',
                              }}
                            >
                              {item == 'First Home Buyer'
                                ? 'FHB'
                                : item == 'Re-Locator'
                                ? 'Reloc'
                                : item == 'Investor'
                                ? 'INV'
                                : item == 'UpSizer'
                                ? 'UpSize'
                                : 'Downsize'}{' '}
                              -
                            </Typography>
                            <Typography
                              sx={{ fontSize: '14px', fontFamily: 'poppins' }}
                            >
                              {item}
                            </Typography>
                          </Box>
                        ))}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems={'center'}
                  sx={{
                    borderTop: '1px solid lightgrey',
                    padding: '15px 20px',
                    fontFamily: 'poppins',
                    marginTop: '15px',
                  }}
                >
                  <Grid>
                    <Typography
                      onClick={() => {
                        handleCloseProfile();
                        history.push('/helpcentre');
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 400,
                        margin: 0,
                        cursor: 'pointer',
                      }}
                    >
                      <InfoIcon />
                      Need Help ?
                    </Typography>
                  </Grid>
                  <Grid>
                    <Button
                      onClick={handleCloseProfile}
                      sx={{
                        padding: '10px 30px',
                        color: 'grey',
                        fontFamily: 'poppins',
                        border: '1px solid lightgrey',
                        textTransform: 'none',
                      }}
                      variant="outlined"
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Popover>

          {/* //Properties Popup Popover */}

          <Popover
            id={idProperty}
            open={openProperty}
            anchorEl={anchorElProperty}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                maxWidth: '540px',
                marginTop: '-20px',
              }}
            >
              <Grid sx={{ padding: '0 30px', marginTop: '50px' }}>
                <Typography
                  sx={{
                    color: '#6C2AD2',
                    fontFamily: 'poppins',
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                >
                  Property Rating
                </Typography>
              </Grid>
              <Grid
                container
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0 30px',
                }}
              >
                <Grid xs={7.5}>
                  <Typography
                    sx={{
                      color: '#112347',
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      fontWeight: 300,
                    }}
                  >
                    The property rating is a whole number between 1 and 10. A
                    higher value indicates greater interest from the buyer for
                    this property. This rating is gathered following the buyer’s
                    inspection of the property and represents how well their
                    expectations were met.
                  </Typography>
                </Grid>
                <Grid xs={4}>
                  <Typography
                    component="div"
                    sx={displayFlex}
                    style={{
                      justifyContent: 'center',
                      position: 'relative',
                      alignItems: 'center',
                    }}
                  >
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                      <CircularProgress
                        variant="determinate"
                        value={propertyProgressRating * 10}
                        sx={{ color: '#10D35E' }}
                        thickness={6}
                        size={100}
                      />

                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: 'absolute',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography
                          variant="caption"
                          component="div"
                          sx={{
                            color: '#000000',
                            ...poppins500,
                            fontSize: '28px',
                          }}
                        >
                          {propertyProgressRating}
                        </Typography>
                      </Box>
                    </Box>

                    <CircularProgress
                      value={100}
                      variant="determinate"
                      sx={{
                        position: 'absolute',
                        color: '#C4C4C461',
                        ...poppins500,
                        fontSize: '28px',
                      }}
                      thickness={6}
                      size={100}
                    />
                  </Typography>

                  <NameTooltip
                    name={buyerName || ''}
                    surname={
                      userType1 === 'Vendor'
                        ? buyerSurName?.charAt(0)?.toUpperCase() || ''
                        : buyerSurName || ''
                    }
                  >
                    <Typography
                      sx={{
                        display: 'block',
                        width: '100%',
                        minWidth: 0,
                        maxWidth: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        textAlign: 'center',
                        color: '#112347',
                        fontFamily: 'Poppins',
                        fontSize: '14px',
                        fontWeight: 600,
                        marginTop: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      {userType1 === 'Vendor'
                        ? `${buyerName || ''} ${
                            buyerSurName?.charAt(0)?.toUpperCase() || ''
                          }`.trim()
                        : `${buyerName || ''} ${buyerSurName || ''}`.trim()}
                    </Typography>
                  </NameTooltip>
                </Grid>
              </Grid>
              <Grid sx={{ padding: '0 30px' }}>
                <Typography
                  sx={{
                    color: '#112347',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 300,
                  }}
                >
                  The buyer’s property rating is updated as the campaign
                  progresses and the buyer’s requirements develop.
                </Typography>
              </Grid>
              <Grid sx={{ padding: '0 30px' }}>
                <Typography
                  sx={{
                    color: '#112347',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 300,
                  }}
                >
                  Most buyers of properties similar to{' '}
                  <span style={{ fontWeight: 600 }}>
                    {
                      propertyDetails?.PropertyDetails?.propertyAddress
                        ?.propertyNo
                    }{' '}
                    {
                      propertyDetails?.PropertyDetails?.propertyAddress
                        ?.streetName
                    }{' '}
                  </span>
                  , purchase with a property rating of{' '}
                  <Box
                    sx={{
                      display: 'inline-flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      mx: 0.5,
                      verticalAlign: 'middle',
                    }}
                  >
                    <PropertyRatingIcon
                      rating={propertyDetails?.PropertyDetails?.averageRating}
                    />
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: '10px',
                        fontWeight: 500,
                        color: '#112347',
                        lineHeight: 1,
                        mt: 0.3,
                      }}
                    >
                      or above
                    </Typography>
                  </Box>{' '}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems={'center'}
                  sx={{
                    borderTop: '1px solid lightgrey',
                    padding: '15px 20px',
                    fontFamily: 'poppins',
                    marginTop: '15px',
                  }}
                >
                  <Grid>
                    <Typography
                      onClick={() => {
                        handleCloseProperty();
                        history.push('/helpcentre');
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 400,
                        margin: 0,
                        cursor: 'pointer',
                      }}
                    >
                      <InfoIcon />
                      Need Help ?
                    </Typography>
                  </Grid>
                  <Grid>
                    <Button
                      onClick={handleCloseProperty}
                      sx={{
                        padding: '10px 30px',
                        color: 'grey',
                        fontFamily: 'poppins',
                        border: '1px solid lightgrey',
                        textTransform: 'none',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          border: '1px solid lightgrey',
                          color: 'grey',
                        },
                      }}
                      variant="outlined"
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Popover>

          {totalItems > 10 && (
            <Stack sx={{ float: 'right' }} style={{ color: '#6C2AD2' }}>
              <Pagination
                style={{
                  '& .MuiPaginationItem-root': {
                    // styles for each pagination item
                    color: '#9C9C9C',
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: '400px',
                    margin: -3,
                    padding: -3,
                  },
                  '& .MuiPaginationItem-root.Mui-selected': {
                    // styles for the currently selected pagination item
                    backgroundColor: 'white',
                    color: '#6C2AD2',
                  },

                  '& .MuiPaginationItem-icon': {
                    color: 'rgba(20, 20, 43, 1)', // Customize the arrow color here
                  },
                }}
                sx={{ p: '20px 0' }}
                count={Math.ceil(totalItems / 10)}
                page={currentPage}
                onChange={handlePageChange}
              />
            </Stack>
          )}
        </Paper>
      </Box>

      {selectedBuyers?.length > 0 && showBackdrop ? (
        selectedBuyers?.map((value, index, open) => {
          return (
            <>
              {!expandFeedback && (
                <BuyerRegisterCard
                  showBackdrop={showBackdrop}
                  selectedBuyers={selectedBuyers}
                  setSelectedBuyers={setSelectedBuyers}
                  count={index}
                  setSelectedBuyerId={setSelectedBuyerId}
                  selectedBuyerId={selectedBuyerId}
                  setShowBackDrop={setShowBackDrop}
                  isPopupOpen={isPopupOpen}
                  buyersId={buyerId}
                  tableData={tableData}
                  openOwner={openOwner}
                  setOpenOwner={setOpenOwner}
                  open={open}
                  rowData={row}
                  userType={userType}
                  setOpen={setOpen}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  index={indexValue}
                  expandFeedback={expandFeedback}
                  setExpandFeedback={setExpandFeedback}
                  isHiddenRightArrow={isHiddenRightArrow}
                  setIsHiddenRightArrow={setIsHiddenRightArrow}
                  position={position}
                  arrayCollection={arrayCollection}
                  buyerId={value}
                  setBuyerId={setBuyerId}
                  setPosition={setPosition}
                  setArrayCollection={setArrayCollection}
                  userName={userName}
                  userMobile={userMobile}
                  userEmail={userEmail}
                  userAddress={userAddress}
                  userNoOfOffers={userNoOfOffers}
                  userPreviousOffer={userPreviousOffer}
                  buyerpropertylist={buyerpropertylist}
                  propertyUniqueId={propertyUniqueId}
                  selectCheckBox={selectCheckBox}
                  setIsPipelineCat={setIsPipelineCat}
                  setPipelineCat={setPipelineCat}
                  setPipelineId={setPipelineId}
                  setIsAppraisal={setIsAppraisal}
                  address={address}
                  onShowChat={onShowChat}
                  buyerCardOpen={open}
                  setBuyerCardOpen={setOpen}
                />
              )}
            </>
          );
        })
      ) : (
        <>
          {!expandFeedback && propertyUniqueId && (
            <BuyerRegisterCard
              selectedBuyers={selectedBuyers}
              setSelectedBuyers={setSelectedBuyers}
              setSelectedBuyerId={setSelectedBuyerId}
              selectedBuyerId={selectedBuyerId}
              showBackdrop={showBackdrop}
              setShowBackDrop={setShowBackDrop}
              isPopupOpen={isPopupOpen}
              buyersId={buyerId}
              openOwner={openOwner}
              setOpenOwner={setOpenOwner}
              open={open}
              rowData={row}
              userType={userType}
              setOpen={setOpen}
              openbuyercard={openbuyercard}
              setOpenbuyercard={setOpenbuyercard}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              index={indexValue}
              expandFeedback={expandFeedback}
              setExpandFeedback={setExpandFeedback}
              isHiddenRightArrow={isHiddenRightArrow}
              setIsHiddenRightArrow={setIsHiddenRightArrow}
              position={position}
              arrayCollection={arrayCollection}
              tableData={tableData}
              buyerId={buyerId}
              setBuyerId={setBuyerId}
              setPosition={setPosition}
              setArrayCollection={setArrayCollection}
              userName={userName}
              userMobile={userMobile}
              userEmail={userEmail}
              userAddress={userAddress}
              userNoOfOffers={userNoOfOffers}
              userPreviousOffer={userPreviousOffer}
              buyerpropertylist={buyerpropertylist}
              propertyUniqueId={propertyUniqueId}
              selectCheckBox={selectCheckBox}
              setIsPipelineCat={setIsPipelineCat}
              setPipelineCat={setPipelineCat}
              setPipelineId={setPipelineId}
              setIsAppraisal={setIsAppraisal}
              address={address}
              onShowChat={onShowChat}
              buyerCardOpen={open}
              setBuyerCardOpen={setOpen}
            />
          )}
        </>
      )}

      {(openFeedback || expandFeedback) && (
        <Feedback
          userEmail={userEmail}
          userType={userType}
          address={address}
          data={feedBackData}
          userName={userName}
          buyerId={buyerId}
          proid={propertyId}
          expandFeedback={expandFeedback}
          setExpandFeedback={setExpandFeedback}
          openFeedback={openFeedback}
          setOpenFeedback={setOpenFeedback}
          proUniqueId={propertyUniqueId}
          propertyUniqueId={propertyUniqueId}
          buyerpropertylist={buyerpropertylist}
          marketShow={false}
          directcomm={directcomm}
          index={null}
          buyerCardOpen={open}
          setBuyerCardOpen={setOpen}
          row={feedBackData?.buyerDetails}
          userInitial={userInitial}
        />
      )}

      <Dialog
        open={forwardtobuyer}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm
              ? '95%'
              : matchesmd
              ? '99%'
              : matches1000
              ? '890px'
              : '980px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchesmd ? '30px 20px' : '30px',
            marginBottom: matchessm ? '87px' : '',
          },
        }}
      >
        <Grid
          container
          sx={{
            overflowY: 'auto',
            position: 'relative',
            '&::-webkit-scrollbar': {
              width: 0,
              height: 0,
            },
            '&': {
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            },
          }}
        >
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {props?.address}
              &nbsp;
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesmd ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Share Buyer's Offer with other Buyers
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '12px' : '16px',
                color: '#666666',
              }}
            >
              Share{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: matchesmd ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  {selectedrowbuyername}
                </b>
              </Typography>
              's offer{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: matchesmd ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  {buyerOfferPrice}
                </b>
              </Typography>{' '}
              to selected buyers.
            </Typography>
          </Grid>

          <Grid
            item
            xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            paddingTop={matchesmd ? '10px' : '30px'}
          >
            <Typography
              sx={{ ...poppins500, fontSize: matchesmd ? '14px' : '18px' }}
              whiteSpace={'nowrap'}
            >
              Offer Amount:{' '}
            </Typography>
          </Grid>
          <Grid
            item
            xs={matchessm ? 6 : 7.5}
            paddingLeft={'20px'}
            paddingTop={matchesmd ? '10px' : '30px'}
          >
            <Typography
              sx={{ ...poppins400, fontSize: matchesmd ? '14px' : '18px' }}
            >
              {buyerOfferPrice}
            </Typography>
          </Grid>

          <Grid
            item
            xs={matchessm ? 12 : 4.5}
            justifyContent={'left'}
            paddingTop={matchesmd ? '10px' : '30px'}
            display={'flex'}
            alignItems={'start'}
          >
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesmd ? '14px' : '18px',
                textAlign: 'right',
              }}
              whiteSpace={'nowrap'}
            >
              Message to Buyer :{' '}
            </Typography>
          </Grid>

          <Grid
            item
            xs={matchessm ? 12 : 7.5}
            paddingLeft={matchessm ? null : '20px'}
            paddingTop={matchesmd ? '10px' : '25px'}
            display={'flex'}
            alignItems={'center'}
          >
            <Typography
              width={'100%'}
              sx={{
                display: 'flex',
                alignItems: 'left',
                justifyContent: 'left',
              }}
            >
              <TextField
                fullWidth
                multiline
                rows={matchessm ? 2 : 4}
                variant="standard"
                sx={{
                  color: '#000000',
                  borderRadius: '5px',
                  padding: '5px',
                  border: '1px solid #F0F0F0',
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                }}
                placeholder="Text message"
                type="text"
                name="name"
                inputProps={{ style: { fontFamily: 'poppins' } }}
                InputProps={{ disableUnderline: 'true' }}
                onChange={(e) => setMessagetToBuyer(e.target.value)}
              />
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            paddingTop={matchesmd ? '10px' : '30px'}
            sx={{
              overflowX: 'scroll !important',
              scrollbarWidth: '2px !important',
            }}
          >
            <EnhancedforwardTable
              buyeroffer={buyeroffer}
              headCells={headCells}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={tableData?.length}
              tableData={tableData}
              setForwardBuyerCheckList={setForwardBuyerCheckList}
              forwardBuyerCheckList={forwardBuyerCheckList}
              setTableCheckedpopup={setTableCheckedpopup}
              tableCheckedpopup={tableCheckedpopup}
              setTableCheckedpopupui={setTableCheckedpopupui}
              tableCheckedpopupui={tableCheckedpopupui}
              propertyDetails={propertyDetails}
              forwardtobuyer={forwardtobuyer}
              selectedrowbuyeridfilter={selectedrowbuyerid}
              forwardUsernameList={forwardUsernameList}
              setForwardUsernameCheckList={setForwardUsernameCheckList}
              forwardSurUsernameList={forwardSurUsernameList}
              setForwardSurUsernameCheckList={setForwardSurUsernameCheckList}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent={'flex-end'}
          gap={2}
          marginTop={2}
          sx={{ position: 'sticky', bottom: '0' }}
        >
          <Grid item>
            <Button
              variant="outlined"
              disabled={loading}
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={() => setForwardtobuyer(!forwardtobuyer)}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
            <Button
              variant="outlined"
              disabled={forwardBuyerCheckList?.length == 0 || loading}
              onClick={() => {
                forwardOfferToBuyerFunc({
                  selectedrowbuyername,
                  buyerOfferPrice,
                });
              }}
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
                cursor:
                  forwardBuyerCheckList?.length == 0 ? 'no-drop' : 'pointer',
              }}
            >
              &nbsp;Share&nbsp;
            </Button>
            {loading && (
              <Grid item>
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openBox}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Forward Offer to Vendor
            </Typography>
          </Grid>
          <Grid item textAlign={'left'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
              whiteSpace={'wrap'}
            >
              You are about to forward{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  {selectedrowbuyername}
                </b>
              </Typography>
              's offer of{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  {selectedOfferPrice ? selectedOfferPrice : buyerOfferPrice}
                </b>
              </Typography>{' '}
              to the Vendor.
            </Typography>
          </Grid>
          {Array.isArray(offerHistory) && offerHistory.length > 1 && (
            <Grid item xs={12} marginTop={3}>
              <Table sx={{ width: '100%', fontFamily: 'poppins' }}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      padding="checkbox"
                      sx={{ fontFamily: 'Poppins' }}
                    />
                    <TableCell sx={{ fontFamily: 'Poppins', fontWeight: 500 }}>
                      Offer
                    </TableCell>
                    <TableCell sx={{ fontFamily: 'Poppins', fontWeight: 500 }}>
                      Offer Type
                    </TableCell>
                    <TableCell sx={{ fontFamily: 'Poppins', fontWeight: 500 }}>
                      Offer Time & Date
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(offerHistory) &&
                    offerHistory.map((offer, index) => (
                      <TableRow key={index}>
                        <TableCell padding="checkbox">
                          <input
                            type="checkbox"
                            checked={selectedOffer == offer?.offerUniqueId}
                            onChange={() =>
                              handleCheckboxChange(
                                offer?.offerUniqueId,
                                offer?.offerPrice
                              )
                            }
                            disabled={frdOfferToVendorLoading}
                          />
                        </TableCell>
                        <TableCell sx={{ fontFamily: 'Poppins' }}>
                          {offer?.offerPrice}
                        </TableCell>
                        <TableCell sx={{ fontFamily: 'Poppins' }}>
                          <Typography
                            sx={{
                              display: 'flex',
                              width: '95px',
                              padding: '3px 6px',
                              alignItems: 'flex-start',
                              justifyContent: 'center',
                              gap: '10px',
                              borderRadius: '5px',
                              background:
                                offer?.isConditional == 1
                                  ? 'rgba(237, 11, 11, 0.60)'
                                  : '#10D35E',
                              marginTop: '-2px',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#FFF',
                                fontFamily: 'Poppins',
                                fontSize: matches380 ? '8px' : '10px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                              }}
                            >
                              {offer?.isConditional == 1
                                ? 'Conditional'
                                : 'Unconditional'}
                            </Typography>
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ fontFamily: 'Poppins' }}>
                          {' '}
                          {offer?.offerUpdatedAt
                            ? dayjs(offer?.offerUpdatedAt).format(
                                'HH:mm:ss DD-MM-YYYY'
                              )
                            : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Grid>
          )}
          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                disabled={frdOfferToVendorLoading}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => {
                  setOpenBox(!openBox);
                  setSelectedOfferPrice(null);
                  setSelectedOffer();
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={
                  frdOfferToVendorLoading ||
                  (offerHistory.length > 1 && !selectedOffer)
                }
                variant="outlined"
                onClick={() => {
                  let input = {};
                  if (offerHistory.length > 1) {
                    input = { offerUniqueId: selectedOffer };
                  } else {
                    input = { offerUniqueId: offerUniqueId };
                  }
                  setFrdOfferToVendorLoading(true);
                  forwardOfferToVendor(input)
                    .then((res) => {
                      if (res?.status == '1') {
                        setOpenBox(!openBox);
                        getListInfo();
                        setUpdatefunc(!updatefunc);
                        setFrdOfferToVendorLoading(false);
                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Success',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'success',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      } else {
                        setFrdOfferToVendorLoading(false);
                        setOpenBox(!openBox);

                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Error',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'error',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      }
                    })
                    .catch((error) => {
                      setFrdOfferToVendorLoading(false);

                      console.error('Forward offer error:', error);
                      setOpenBox(!openBox);
                      Swal.fire({
                        title: 'Error',
                        text: 'Something went wrong. Please try again.',
                        showDenyButton: false,
                        showCancelButton: false,
                        icon: 'error',
                        confirmButtonText: 'Close',
                      });
                    })
                    .finally(() => {
                      setSelectedOffer(null);
                      setSelectedOfferPrice(null);
                    });
                }}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Forward
              </Button>
              {frdOfferToVendorLoading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openVendorStatusBox}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '100%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Pendingwarning />
            <Typography
              sx={{ ...poppins500, fontSize: '24px', paddingLeft: '12px' }}
            >
              Notify Buyer
            </Typography>
          </Grid>
          <Grid
            item
            xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            paddingTop={'10px'}
          >
            <Typography
              sx={{ ...poppins500, fontSize: '18px' }}
              whiteSpace={'nowrap'}
            >
              You are about to notify{' '}
              <Typography component="span">
                {' '}
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {selectedrowbuyername}
                </b>
              </Typography>{' '}
              of the vendor's response.
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginTop={4}
          >
            <Grid item>
              <Button
                disabled={forwardVendorLoading}
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                }}
                onClick={() => setOpenVendorStatusBox(!openVendorStatusBox)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={forwardVendorLoading}
                variant="outlined"
                onClick={() => {
                  let newArr = [];
                  let obj = { offerUniqueId: offerUniqueId };
                  newArr.push(obj);
                  let input = {
                    offerUniqueId: newArr,
                    offerStatus: offerStatus,
                  };
                  setForwardVendorLoading(true);
                  forwardOfferToBuyer(input)
                    .then((res) => {
                      if (res?.status == '1') {
                        if (isNotEmptyArray(res?.dataForBuyerAck))
                          Moxoseparationinlisting(
                            'offerSharingToBuyer',
                            res?.dataForBuyerAck
                          );
                        setOpenVendorStatusBox(!openVendorStatusBox);
                        getListInfo();
                        setForwardVendorLoading(false);
                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Success',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'success',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                        setForwardVendorLoading(false);
                      } else {
                        setForwardVendorLoading(false);
                        setOpenVendorStatusBox(!openVendorStatusBox);

                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Error',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'error',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      }
                    })
                    .catch(() => setForwardVendorLoading(false));
                }}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                }}
              >
                Confirm
              </Button>
              {forwardVendorLoading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openforwardbuyeractiontovendorBox}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '100%' : '700px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Warning />
            <Typography
              sx={{ ...poppins500, fontSize: '24px', paddingLeft: '12px' }}
            >
              Forward Buyer action to Vendor Counter Offer
            </Typography>
          </Grid>
          <Grid
            item
            xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            paddingTop={'10px'}
          >
            <Typography
              sx={{ ...poppins500, fontSize: '18px' }}
              whiteSpace={'nowrap'}
            >
              Do you like to forward this Buyer action to Vendor Counter Offer?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginTop={4}
          >
            <Grid item>
              <Button
                disabled={buyerToVendorLoading}
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                }}
                onClick={() =>
                  setOpenForwardBuyerActionToVendorBox(
                    !openforwardbuyeractiontovendorBox
                  )
                }
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={buyerToVendorLoading}
                variant="outlined"
                onClick={() => {
                  buyeraction();
                }}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                }}
              >
                Forward
              </Button>
              {buyerToVendorLoading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openpublishwinnerbox}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              {propertyDetails?.PropertyDetails?.timerStatus == 'Start'
                ? `Nominate Winner - End Stage ${
                    propertyDetails?.PropertyDetails?.stage == 'ST1' ? '1' : '2'
                  }`
                : 'Nominate Winner'}
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign={'left'} paddingTop={'10px'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                width: '100%',
              }}
              whiteSpace={'wrap'}
            >
              {propertyDetails?.PropertyDetails?.timerStatus != 'Start' ? (
                <>
                  Do you like to nominate{' '}
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    {' '}
                    {selectedrowbuyername}{' '}
                  </b>{' '}
                  as a Winner?{' '}
                </>
              ) : propertyDetails?.PropertyDetails?.stage == 'ST1' ? (
                <>
                  You have selected to nominate{' '}
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    {selectedrowbuyername}
                  </b>{' '}
                  as the winner for{' '}
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    {address}
                  </b>
                  .<br />
                  <br />
                  By taking this action the campaign will end immediately and
                  will not progress to Stage 2. No further offers will be
                  accepted.
                </>
              ) : (
                <>
                  You have selected to nominate{' '}
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    {selectedrowbuyername}
                  </b>{' '}
                  as the winner{' '}
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    {address}
                  </b>
                  .<br />
                  <br />
                  By taking this action the campaign including Stage 2 timer
                  will end and no further offers will be accepted.
                </>
              )}
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={matchessm ? '5px' : 2}
            marginTop={matchessm ? '15px' : 5}
            alignItems={'center'}
          >
            <Grid item>
              <Button
                disabled={publishLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 18px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => setOpenPublishWinnerBox(!openpublishwinnerbox)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '15px',
              }}
            >
              <Button
                disabled={publishLoader}
                variant="outlined"
                onClick={() => {
                  publishwinnerfun();
                  setBuyerId(paymentStatus?.buyerDetails?.user?.userId);
                }}
                style={{
                  padding: matchessm ? '7px 17px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Nominate
              </Button>
              {publishLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openBoxAnother}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '100%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Warning />
            <Typography
              sx={{ ...poppins500, fontSize: '24px', paddingLeft: '12px' }}
            >
              Confirming Acceptance
            </Typography>
          </Grid>
          <Grid
            item
            xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            paddingTop={'10px'}
          >
            <Typography
              sx={{ ...poppins500, fontSize: '18px' }}
              whiteSpace={'nowrap'}
            >
              Do you like to add this buyer to Stage 2?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginTop={4}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                }}
                onClick={() => setOpenBoxAnother(!openBoxAnother)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  let input = {
                    offerUniqueId: offerUniqueId,
                  };

                  addBuyerToStagingTwo(input)
                    .then((res) => {
                      if (res?.status == '1') {
                        setOpenBoxAnother(!openBoxAnother);
                        getListInfo();
                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Success',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'success',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      } else {
                        setOpenBoxAnother(!openBoxAnother);

                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Error',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'error',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      }
                    })
                    .catch((err) => console.log(err));
                }}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                }}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      {openViewDialog && (
        <ViewCommenceEsignPdf
          open={openViewDialog}
          onClose={handleCloseView}
          taskPath={selectedRowFor66W?.signed66WFile}
          streetName={address}
          matchessm={matchessm}
          wStatus={true}
          primaryUserTypeValue={userType}
        />
      )}
    </>
  );
}
